var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/cloud/index.ts
var cloud_exports = {};
__export(cloud_exports, {
  AcceptPerformerRequestValidation: () => AcceptPerformerRequestValidation,
  AcknowledgeFareAssignationValidation: () => AcknowledgeFareAssignationValidation,
  AcknowledgeNotificationValidation: () => AcknowledgeNotificationValidation,
  AssignFareValidation: () => AssignFareValidation,
  CancelAccommodationRequestValidation: () => CancelAccommodationRequestValidation,
  CancelAccommodationValidation: () => CancelAccommodationValidation,
  CancelConfirmFareValidation: () => CancelConfirmFareValidation,
  CancelJourneyValidation: () => CancelJourneyValidation,
  ClearAnomalyValidation: () => ClearAnomalyValidation,
  CloseMultipleBedsValidation: () => CloseMultipleBedsValidation,
  ConfirmFareValidation: () => ConfirmFareValidation,
  CreateAccommodationRequestValidation: () => CreateAccommodationRequestValidation,
  CreateAreaValidation: () => CreateAreaValidation,
  CreateExternalSessionValidation: () => CreateExternalSessionValidation,
  CreateExternalTransportValidation: () => CreateExternalTransportValidation,
  CreateFareValidation: () => CreateFareValidation,
  CreateHealthCenterMappingFromJSONValidation: () => CreateHealthCenterMappingFromJSONValidation,
  CreateHealthCenterMappingValidation: () => CreateHealthCenterMappingValidation,
  CreateHealthCenterValidation: () => CreateHealthCenterValidation,
  CreateHealthcareEnvironmentalCleaningValidation: () => CreateHealthcareEnvironmentalCleaningValidation,
  CreateIncidentValidation: () => CreateIncidentValidation,
  CreateJourneyStepValidation: () => CreateJourneyStepValidation,
  CreateJourneyValidation: () => CreateJourneyValidation,
  CreatePartialPatientValidation: () => CreatePartialPatientValidation,
  CreatePathDefaultTimeValidation: () => CreatePathDefaultTimeValidation,
  CreatePerformerRequestValidation: () => CreatePerformerRequestValidation,
  CreatePractitionerValidation: () => CreatePractitionerValidation,
  CreateThesaurusItemValidation: () => CreateThesaurusItemValidation,
  CreateUnitValidation: () => CreateUnitValidation,
  CreateUserValidation: () => CreateUserValidation,
  DeleteAreaValidation: () => DeleteAreaValidation,
  GetAnsOrganizationValidation: () => GetAnsOrganizationValidation,
  GetAnsPractitionersValidation: () => GetAnsPractitionersValidation,
  GetHealthCenterEmergencyOccupanciesValidation: () => GetHealthCenterEmergencyOccupanciesValidation,
  GetHl7AdtMessagesValidation: () => GetHl7AdtMessagesValidation,
  GetHl7SiuMessagesValidation: () => GetHl7SiuMessagesValidation,
  GetOverviewStatisticsValidation: () => GetOverviewStatisticsValidation,
  GetPatientContextualLinkValidation: () => GetPatientContextualLinkValidation,
  GetPortersValidation: () => GetPortersValidation,
  ImportStructureValidation: () => ImportStructureValidation,
  ImportThesaurusValidation: () => ImportThesaurusValidation,
  LinkExternalUserValidation: () => LinkExternalUserValidation,
  LogoutPorterValidation: () => LogoutPorterValidation,
  MoveAreaValidation: () => MoveAreaValidation,
  NotificationStatsValidation: () => NotificationStatsValidation,
  ReadAllNotificationsValidation: () => ReadAllNotificationsValidation,
  RefreshVisitValidation: () => RefreshVisitValidation,
  RejectPerformerRequestValidation: () => RejectPerformerRequestValidation,
  RemoveFareAssignationValidation: () => RemoveFareAssignationValidation,
  RemovePractitionerValidation: () => RemovePractitionerValidation,
  ResetPorterAfterLogoutValidation: () => ResetPorterAfterLogoutValidation,
  SetConfigVersionValidation: () => SetConfigVersionValidation,
  SetPorterUnitsValidation: () => SetPorterUnitsValidation,
  StepSchedulingValidation: () => StepSchedulingValidation,
  TakeBreakValidation: () => TakeBreakValidation,
  UnreadNotificationValidation: () => UnreadNotificationValidation,
  UpdateAccommodationRequestValidation: () => UpdateAccommodationRequestValidation,
  UpdateAreaAvailabilityPeriodsValidation: () => UpdateAreaAvailabilityPeriodsValidation,
  UpdateAreaValidation: () => UpdateAreaValidation,
  UpdateEmergencyOccupancyValidation: () => UpdateEmergencyOccupancyValidation,
  UpdateExternalTransportValidation: () => UpdateExternalTransportValidation,
  UpdateFareValidation: () => UpdateFareValidation,
  UpdateHealthCenterValidation: () => UpdateHealthCenterValidation,
  UpdateHealthcareEnvironmentalCleaningValidation: () => UpdateHealthcareEnvironmentalCleaningValidation,
  UpdateInstallationValidation: () => UpdateInstallationValidation,
  UpdateJourneyStepValidation: () => UpdateJourneyStepValidation,
  UpdateJourneyValidation: () => UpdateJourneyValidation,
  UpdateOccupancyValidation: () => UpdateOccupancyValidation,
  UpdatePractitionerValidation: () => UpdatePractitionerValidation,
  UpdateThesaurusItemValidation: () => UpdateThesaurusItemValidation,
  UpdateUnitValidation: () => UpdateUnitValidation,
  UpdateUserValidation: () => UpdateUserValidation,
  UpsertAccommodationValidation: () => UpsertAccommodationValidation,
  acceptPerformerRequest: () => acceptPerformerRequest,
  acknowledgeFareAssignation: () => acknowledgeFareAssignation_default,
  acknowledgeNotification: () => acknowledgeNotification_default,
  assignFare: () => assignFare_default,
  cancelAccommodation: () => cancelAccommodation,
  cancelAccommodationRequest: () => cancelAccommodationRequest,
  cancelConfirmFare: () => cancelConfirmFare_default,
  cancelFare: () => cancelFare_default,
  cancelJourney: () => cancelJourney,
  clearAnomaly: () => clearAnomaly_default,
  closeMultipleBeds: () => closeMultipleBeds_default,
  confirmFare: () => confirmFare_default,
  createAccommodationRequest: () => createAccommodationRequest,
  createArea: () => createArea_default,
  createExternalSession: () => createExternalSession,
  createExternalTransport: () => createExternalTransport,
  createFare: () => createFare_default,
  createHealthcareEnvironmentalCleaning: () => createHealthcareEnvironmentalCleaning,
  createHeathCenter: () => createHealthCenter_default,
  createHeathCenterMapping: () => createHealthCenterMapping_default,
  createHeathCenterMappingFromJSON: () => createHealthCenterMappingFromJSON_default,
  createIncident: () => createIncident_default,
  createJourney: () => createJourney,
  createPartialPatient: () => createPartialPatient_default,
  createPathDefaultTime: () => createPathDefaultTime_default,
  createPerformerRequest: () => createPerformerRequest,
  createPractitioner: () => createPractitioner,
  createUnit: () => createUnit_default,
  createUser: () => createUser_default,
  deleteArea: () => deleteArea_default,
  dispatchFare: () => dispatchFare_default,
  externalTransportStatus: () => externalTransportStatus,
  fareTick: () => fareTick_default,
  getAnsOrganizations: () => getAnsOrganizations,
  getAnsPractitioners: () => getAnsPractitioners,
  getHealthCenterEmergencyOccupancies: () => getHealthCenterEmergencyOccupancies_default,
  getHealthCenterGroups: () => getHealthCenterGroups_default,
  getHl7AdtMessages: () => getHl7AdtMessages_default,
  getHl7Locations: () => getHl7Locations_default,
  getHl7SiuMessages: () => getHl7SiuMessages_default,
  getOverviewStatistics: () => getOverviewStatistics_default,
  getPatientContextualLink: () => getPatientContextualLink,
  getPorters: () => getPorters_default,
  getRegionStatistics: () => getRegionStatistics,
  importStructure: () => importStructure_default,
  importThesaurus: () => importThesaurus_default,
  leaveBreak: () => leaveBreak_default,
  linkExternalUser: () => linkExternalUser_default,
  logoutPorter: () => logoutPorter_default,
  moveArea: () => moveArea_default,
  notificationStats: () => notificationStats_default,
  readAllNotifications: () => readAllNotifications_default,
  refreshVisit: () => refreshVisit_default,
  rejectPerformerRequest: () => rejectPerformerRequest,
  removeFareAssignation: () => removeFareAssignation_default,
  removePractitioner: () => removePractitioner,
  reportTypes: () => reportTypes,
  resetPorterAfterLogout: () => resetPorterAfterLogout_default,
  setConfigVersion: () => setConfigVersion_default,
  setPorterUnits: () => setPorterUnits_default,
  stepScheduling: () => stepScheduling,
  takeBreak: () => takeBreak_default,
  toggleAutodispatch: () => toggleAutodispatch_default,
  unreadNotification: () => unreadNotification_default,
  updateAccommodationRequest: () => updateAccommodationRequest,
  updateArea: () => updateArea_default,
  updateAreaAvailabilityPeriods: () => updateAreaAvailabilityPeriods_default,
  updateEmergencyOccupancy: () => updateEmergencyOccupancy_default,
  updateExternalTransport: () => updateExternalTransport,
  updateFare: () => updateFare_default,
  updateHealthCenter: () => updateHealthCenter_default,
  updateHealthcareEnvironmentalCleaning: () => updateHealthcareEnvironmentalCleaning,
  updateInstallation: () => updateInstallation_default,
  updateJourney: () => updateJourney,
  updateOccupancy: () => updateOccupancy_default,
  updatePractitioner: () => updatePractitioner,
  updateUnit: () => updateUnit_default,
  updateUser: () => updateUser_default,
  updateVisit: () => updateVisit_default,
  updateVisitValidation: () => updateVisitValidation,
  upsertAccommodation: () => upsertAccommodation,
  userTick: () => userTick_default
});

// src/cloud/api/createExternalSession.ts
import * as Yup from "yup";

// src/parse-instance.browser.ts
import Api from "parse/dist/parse.min.js";
var parse_instance_browser_default = Api;

// src/cloud/api/createExternalSession.ts
var CreateExternalSessionValidation = Yup.object({
  healthCenterId: Yup.string().required()
});
var createExternalSession = (params, options) => parse_instance_browser_default.Cloud.run(
  "create-external-session",
  params,
  options
);

// src/cloud/createThesaurusItem.ts
import * as Yup2 from "yup";
var CreateThesaurusItemValidation = Yup2.object({
  healthCenterId: Yup2.string().required(),
  reason: Yup2.string().required(),
  expectedDurationInMinutes: Yup2.number(),
  redirectionUnitIds: Yup2.array(Yup2.string().required())
});

// src/cloud/external/ans/getAnsOrganizations.ts
import * as Yup3 from "yup";
var GetAnsOrganizationValidation = Yup3.object({
  finessList: Yup3.array().of(Yup3.string().required()).required()
});
var getAnsOrganizations = (params, options) => parse_instance_browser_default.Cloud.run(
  "get-ans-organizations",
  params,
  options
);

// src/cloud/external/ans/getAnsPractitioners.ts
import * as Yup4 from "yup";
var optionsValidation = Yup4.object({
  count: Yup4.number(),
  bindOrganizations: Yup4.boolean(),
  bindRpps: Yup4.boolean()
});
var GetAnsPractitionersValidation = Yup4.object({
  search: Yup4.string().required(),
  options: optionsValidation.default(void 0)
});
var getAnsPractitioners = (params, options) => parse_instance_browser_default.Cloud.run(
  "get-ans-practitioners",
  params,
  options
);

// src/cloud/external/viaTrajectoire/getPatientContextualLink.ts
import * as Yup5 from "yup";
var reportTypes = { SANITARY: "sanitaire", GREAT_AGE: "grand-age" };
var GetPatientContextualLinkValidation = Yup5.object({
  id: Yup5.string().required(),
  type: Yup5.string().required().oneOf(Object.values(reportTypes))
});
var getPatientContextualLink = (params, options) => parse_instance_browser_default.Cloud.run(
  "get-patient-contextual-link",
  params,
  options
);

// src/cloud/getRegionStatistics.ts
var getRegionStatistics = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "get-region-statistics",
    params,
    options
  );
};

// src/cloud/hl7/getHl7AdtMessages.ts
import * as Yup6 from "yup";
var GetHl7AdtMessagesValidation = Yup6.object({
  patientId: Yup6.string().required(),
  from: Yup6.date().required()
});
var getHl7AdtMessages = (params, options) => parse_instance_browser_default.Cloud.run(
  "get-hl7-adt-messages",
  params,
  options
);
var getHl7AdtMessages_default = getHl7AdtMessages;

// src/cloud/hl7/getHl7Locations.ts
var getHl7Locations = (options) => parse_instance_browser_default.Cloud.run("get-hl7-locations", null, options);
var getHl7Locations_default = getHl7Locations;

// src/cloud/hl7/getHl7SiuMessages.ts
import * as Yup7 from "yup";
var GetHl7SiuMessagesValidation = Yup7.object({
  patientId: Yup7.string().required(),
  from: Yup7.date().required()
});
var getHl7SiuMessages = (params, options) => parse_instance_browser_default.Cloud.run(
  "get-hl7-siu-messages",
  params,
  options
);
var getHl7SiuMessages_default = getHl7SiuMessages;

// src/cloud/steps/HealthcareEnvironmentalCleaning/create.ts
import * as Yup8 from "yup";

// src/utils/date.utils.ts
function subMonths(date22, amount) {
  date22.setMonth(date22.getMonth() - amount);
  return date22;
}
function addMonths(date22, amount) {
  date22.setMonth(date22.getMonth() + amount);
  return date22;
}
var maxDate = /* @__PURE__ */ new Date(41023584e5);
var minDate = /* @__PURE__ */ new Date(0);
var DEFAULT_HEALTH_CENTER_TIMEZONE = "Europe/Paris";

// src/models/ParseClass.ts
var ParseClass = class extends parse_instance_browser_default.Object {
  constructor(className, attributes) {
    super(className, attributes);
  }
  Get(attr) {
    return this.get(attr);
  }
  Set(attr, val) {
    if (val === void 0) {
      return this.unset(attr);
    }
    return this.set(attr, val);
  }
  Unset(attr) {
    return this.unset(attr);
  }
};
var ParseUser = class extends parse_instance_browser_default.User {
  constructor(attributes) {
    super(attributes);
  }
  Get(attr) {
    return this.get(attr);
  }
  Set(attr, val) {
    if (val === void 0) {
      return this.unset(attr);
    }
    return this.set(attr, val);
  }
  Unset(attr) {
    return this.unset(attr);
  }
};

// src/models/steps/Accommodation.ts
var specificitiesSorter = (a, b) => specificitiesOrder[a] - specificitiesOrder[b];
var specificitiesOrder = {
  COVID: 1,
  ISOLATED: 2,
  ISOLATED_AIR: 3,
  ISOLATED_CONTACT: 4,
  ISOLATED_DROPLET: 5,
  ISOLATED_PROTECTOR: 6,
  ACCOMMODATED: 7,
  WAITING_FOR_DOWNSTREAM_BED: 8,
  PRIVATE_ROOM: 9
};
var isolatedSpecificities = [
  "ISOLATED",
  // Deprecated Not available anymore
  "ISOLATED_AIR",
  "ISOLATED_DROPLET",
  "ISOLATED_CONTACT",
  "ISOLATED_PROTECTOR"
];
var accommodationSpecificities = [
  ...["COVID", ...isolatedSpecificities, "ACCOMMODATED", "WAITING_FOR_DOWNSTREAM_BED", "PRIVATE_ROOM"]
].sort(specificitiesSorter);
var accommodationStatus = [...["PLANNED", "CANCELLED", "IN_PROGRESS", "COMPLETED"]];
var isIsolatedSpecificity = (specificity) => isolatedSpecificities.includes(specificity);
var Accommodation = class extends ParseClass {
  constructor(attributes) {
    super("Accommodation", attributes);
  }
  get specificities() {
    return this.Get("specificities")?.sort(specificitiesSorter);
  }
  set specificities(val) {
    this.Set("specificities", val);
  }
  get isEstimatedEnd() {
    return this.Get("isEstimatedEnd");
  }
  set isEstimatedEnd(val) {
    this.Set("isEstimatedEnd", val);
  }
  get externalIds() {
    return this.Get("externalIds");
  }
  set externalIds(val) {
    this.Set("externalIds", val);
  }
  get bed() {
    return this.Get("bed");
  }
  set bed(val) {
    this.Set("bed", val);
  }
  get bedHistory() {
    return this.Get("bedHistory");
  }
  set bedHistory(val) {
    this.Set("bedHistory", val);
  }
  get unit() {
    return this.Get("unit");
  }
  set unit(val) {
    this.Set("unit", val);
  }
  get responsibleUnit() {
    return this.Get("responsibleUnit");
  }
  set responsibleUnit(val) {
    this.Set("responsibleUnit", val);
  }
  get status() {
    return this.Get("status");
  }
  set status(val) {
    this.Set("status", val);
  }
  get comment() {
    return this.Get("comment");
  }
  set comment(val) {
    this.Set("comment", val);
  }
  get reason() {
    return this.Get("reason");
  }
  set reason(val) {
    this.Set("reason", val);
  }
  get thesaurusItem() {
    return this.Get("thesaurusItem");
  }
  set thesaurusItem(val) {
    this.Set("thesaurusItem", val);
  }
  get basedOn() {
    return this.Get("basedOn");
  }
  set basedOn(val) {
    this.Set("basedOn", val);
  }
  get startAt() {
    return this.Get("startAt");
  }
  set startAt(val) {
    this.Set("startAt", val);
  }
  get endAt() {
    const endAt = this.Get("endAt");
    if (endAt && endAt.getTime() >= maxDate.getTime()) {
      return void 0;
    }
    return endAt;
  }
  set endAt(val) {
    this.Set("endAt", val || maxDate);
  }
  get startAtHistory() {
    return this.Get("startAtHistory");
  }
  set startAtHistory(val) {
    this.Set("startAtHistory", val);
  }
  get patient() {
    return this.Get("patient");
  }
  set patient(val) {
    this.Set("patient", val);
  }
  get visit() {
    return this.Get("visit");
  }
  set visit(val) {
    this.Set("visit", val);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get practitioners() {
    return this.Get("practitioners");
  }
  set practitioners(val) {
    this.Set("practitioners", val);
  }
  get createdBy() {
    return this.Get("createdBy");
  }
  set createdBy(val) {
    this.Set("createdBy", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("Accommodation", Accommodation);

// src/models/steps/AccommodationRequest.ts
var REQUEST_TYPES = ["DIRECT_ADMISSION", "INTERNAL_MUTATION", "BED_MUTATION"];
var AccommodationRequest = class extends ParseClass {
  constructor(attributes) {
    super("AccommodationRequest", attributes);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get reason() {
    return this.Get("reason");
  }
  set reason(val) {
    this.Set("reason", val);
  }
  get thesaurusItem() {
    return this.Get("thesaurusItem");
  }
  set thesaurusItem(val) {
    this.Set("thesaurusItem", val);
  }
  get status() {
    return this.Get("status");
  }
  set status(val) {
    this.Set("status", val);
  }
  get performerRequests() {
    return this.Get("performerRequests");
  }
  set performerRequests(val) {
    this.Set("performerRequests", val);
  }
  get specificities() {
    return this.Get("specificities");
  }
  set specificities(val) {
    this.Set("specificities", val);
  }
  get comment() {
    return this.Get("comment");
  }
  set comment(val) {
    this.Set("comment", val);
  }
  get visit() {
    return this.Get("visit");
  }
  set visit(val) {
    this.Set("visit", val);
  }
  get requestType() {
    return this.Get("requestType");
  }
  set requestType(val) {
    this.Set("requestType", val);
  }
  get directAdmissionOrigin() {
    return this.Get("directAdmissionOrigin");
  }
  set directAdmissionOrigin(val) {
    this.Set("directAdmissionOrigin", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("AccommodationRequest", AccommodationRequest);

// src/models/steps/Appointment.ts
var appointmentStatus = [...["PLANNED", "CANCELLED", "IN_PROGRESS", "COMPLETED"]];
var Appointment = class extends ParseClass {
  constructor(attributes) {
    super("Appointment", attributes);
  }
  get start() {
    return this.Get("start");
  }
  set start(val) {
    this.Set("start", val);
  }
  get end() {
    return this.Get("end");
  }
  set end(val) {
    this.Set("end", val);
  }
  set externalIds(value) {
    this.Set("externalIds", value && value.length === 0 ? void 0 : value);
  }
  get externalIds() {
    return this.Get("externalIds");
  }
  get patient() {
    return this.Get("patient");
  }
  set patient(value) {
    this.Set("patient", value);
  }
  get location() {
    return this.Get("location");
  }
  set location(value) {
    this.Set("location", value);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get comment() {
    return this.Get("comment");
  }
  set comment(val) {
    this.Set("comment", val);
  }
  get status() {
    return this.Get("status");
  }
  set status(val) {
    this.Set("status", val);
  }
  get visit() {
    return this.Get("visit");
  }
  set visit(val) {
    this.Set("visit", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("Appointment", Appointment);

// src/models/steps/ExternalPatientTransport.ts
var externalPatientTransportPosition = ["LYING_DOWN", "SITTING_UP"];
var ExternalPatientTransport = class extends ParseClass {
  constructor(attributes) {
    super("ExternalPatientTransport", attributes);
  }
  get status() {
    return this.Get("status");
  }
  set status(val) {
    this.Set("status", val);
  }
  get startAt() {
    return this.Get("startAt");
  }
  set startAt(val) {
    this.Set("startAt", val);
  }
  get endAt() {
    return this.Get("endAt");
  }
  set endAt(val) {
    this.Set("endAt", val);
  }
  get patient() {
    return this.Get("patient");
  }
  set patient(val) {
    this.Set("patient", val);
  }
  get visit() {
    return this.Get("visit");
  }
  set visit(val) {
    this.Set("visit", val);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get externalId() {
    return this.Get("externalId");
  }
  set externalId(val) {
    this.Set("externalId", val);
  }
  get comment() {
    return this.Get("comment");
  }
  set comment(val) {
    this.Set("comment", val);
  }
  get farePosition() {
    return this.Get("farePosition");
  }
  set farePosition(val) {
    this.Set("farePosition", val);
  }
  get reason() {
    return this.Get("reason");
  }
  set reason(val) {
    this.Set("reason", val);
  }
  get startAtHistory() {
    return this.Get("startAtHistory");
  }
  set startAtHistory(val) {
    this.Set("startAtHistory", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("ExternalPatientTransport", ExternalPatientTransport);

// src/models/steps/HealthcareEnvironmentalCleaning.ts
var healthcareEnvironmentalCleaningStatus = [
  "CANCELED",
  "DONE",
  "IN_PROGRESS",
  "PLANNED"
];
var HealthcareEnvironmentalCleaning = class extends ParseClass {
  constructor(attributes) {
    super("HealthcareEnvironmentalCleaning", attributes);
  }
  get status() {
    return this.Get("status");
  }
  set status(val) {
    this.Set("status", val);
  }
  get startAt() {
    return this.Get("startAt");
  }
  set startAt(val) {
    this.Set("startAt", val);
  }
  get endAt() {
    return this.Get("endAt");
  }
  set endAt(val) {
    this.Set("endAt", val);
  }
  get location() {
    return this.Get("location");
  }
  set location(val) {
    this.Set("location", val);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get externalId() {
    return this.Get("externalId");
  }
  set externalId(val) {
    this.Set("externalId", val);
  }
  get unit() {
    return this.Get("unit");
  }
  set unit(val) {
    this.Set("unit", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("HealthcareEnvironmentalCleaning", HealthcareEnvironmentalCleaning);

// src/models/steps/PerformerRequest.ts
var PerformerRequest = class extends ParseClass {
  constructor(attributes) {
    super("PerformerRequest", attributes);
  }
  get status() {
    return this.Get("status");
  }
  set status(val) {
    this.Set("status", val);
  }
  get performer() {
    return this.Get("performer");
  }
  set performer(val) {
    this.Set("performer", val);
  }
  get rejectionReason() {
    return this.Get("rejectionReason");
  }
  set rejectionReason(val) {
    this.Set("rejectionReason", val);
  }
  get request() {
    return this.Get("request");
  }
  set request(val) {
    this.Set("request", val);
  }
  get fulfilledBy() {
    return this.Get("fulfilledBy");
  }
  set fulfilledBy(val) {
    this.Set("fulfilledBy", val);
  }
  get fulfilledAt() {
    return this.Get("fulfilledAt");
  }
  set fulfilledAt(val) {
    this.Set("fulfilledAt", val);
  }
  get createdBy() {
    return this.Get("createdBy");
  }
  set createdBy(val) {
    this.Set("createdBy", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("PerformerRequest", PerformerRequest);

// src/cloud/steps/HealthcareEnvironmentalCleaning/create.ts
var CreateHealthcareEnvironmentalCleaningValidation = Yup8.object().shape({
  endAt: Yup8.date(),
  externalId: Yup8.string(),
  startAt: Yup8.date(),
  status: Yup8.string().oneOf(healthcareEnvironmentalCleaningStatus).required(),
  finess: Yup8.string().required(),
  locationId: Yup8.string().required()
});
var createHealthcareEnvironmentalCleaning = (params, options) => parse_instance_browser_default.Cloud.run(
  "create-bionet",
  params,
  options
);

// src/cloud/steps/HealthcareEnvironmentalCleaning/update.ts
import * as Yup9 from "yup";
var UpdateHealthcareEnvironmentalCleaningValidation = Yup9.object({
  endAt: Yup9.date(),
  externalId: Yup9.string(),
  startAt: Yup9.date(),
  status: Yup9.string().oneOf(healthcareEnvironmentalCleaningStatus),
  locationId: Yup9.string()
});
var updateHealthcareEnvironmentalCleaning = (params, options) => parse_instance_browser_default.Cloud.run(
  "update-bionet",
  params,
  options
);

// src/cloud/steps/updateAccommodationRequest.ts
import * as Yup10 from "yup";
var UpdateAccommodationRequestValidation = Yup10.object({
  id: Yup10.string().required(),
  reason: Yup10.string().notRequired(),
  thesaurusItemId: Yup10.string().notRequired(),
  comment: Yup10.string().notRequired(),
  specificities: Yup10.array().of(Yup10.string().oneOf(accommodationSpecificities).required()),
  directAdmissionOrigin: Yup10.string().notRequired()
});
var updateAccommodationRequest = (params, options) => parse_instance_browser_default.Cloud.run(
  "update-accommodation-request",
  params,
  options
);

// src/cloud/steps/acceptPerformerRequest.ts
import * as Yup11 from "yup";
var AcceptPerformerRequestValidation = Yup11.object({
  id: Yup11.string().required(),
  startAt: Yup11.date().required()
});
var acceptPerformerRequest = (params, options) => parse_instance_browser_default.Cloud.run(
  "accept-performer-request",
  params,
  options
);

// src/cloud/steps/cancelAccommodation.ts
import * as Yup12 from "yup";
var CancelAccommodationValidation = Yup12.object({
  accommodationId: Yup12.string().required()
});
var cancelAccommodation = (params, options) => parse_instance_browser_default.Cloud.run(
  "cancel-accommodation",
  params,
  options
);

// src/cloud/steps/cancelAccommodationRequest.ts
import * as Yup13 from "yup";
var CancelAccommodationRequestValidation = Yup13.object({
  requestId: Yup13.string().required()
});
var cancelAccommodationRequest = (params, options) => parse_instance_browser_default.Cloud.run(
  "cancel-accommodation-request",
  params,
  options
);

// src/cloud/steps/createAccommodationRequest.ts
import * as Yup14 from "yup";
var CreateAccommodationRequestValidation = Yup14.object({
  expectedAt: Yup14.date(),
  locationId: Yup14.string(),
  visitId: Yup14.string().required(),
  performerUnitIds: Yup14.array(Yup14.string().required()).when("requestType", {
    is: "DIRECT_ADMISSION",
    then: () => Yup14.array(Yup14.string().required()).required()
  }),
  specificities: Yup14.array(Yup14.string().oneOf(accommodationSpecificities).required()),
  requestType: Yup14.string().oneOf(REQUEST_TYPES).required(),
  reason: Yup14.string(),
  thesaurusItemId: Yup14.string(),
  directAdmissionOrigin: Yup14.string().when("requestType", {
    is: "DIRECT_ADMISSION",
    then: () => Yup14.string().required()
  }),
  comment: Yup14.string()
});
var createAccommodationRequest = (params, options) => parse_instance_browser_default.Cloud.run(
  "create-accommodation-request",
  params,
  options
);

// src/cloud/steps/createExternalTransport.ts
import * as Yup15 from "yup";

// src/models/patient/Patient.ts
var patientGender = ["FEMALE", "MALE", "UNKNOWN"];
var patientCreationSources = ["HL7", "HPRIMXML", "MANUAL", "UNKNOWN"];
var patientOutcomeTypes = ["Domicile", "SAD", "EHPAD", "SMR", "Autre"];
var Patient = class extends ParseClass {
  constructor(attributes) {
    super("Patient", attributes);
  }
  get firstName() {
    return this.Get("firstName");
  }
  set firstName(val) {
    this.Set("firstName", val);
  }
  get birthdate() {
    return this.Get("birthdate");
  }
  set birthdate(val) {
    this.Set("birthdate", val);
  }
  get birthplace() {
    return this.Get("birthplace");
  }
  set birthplace(val) {
    this.Set("birthplace", val);
  }
  get birthdateAsString() {
    return this.Get("birthdateAsString");
  }
  set birthdateAsString(val) {
    this.Set("birthdateAsString", val);
  }
  get ipp() {
    return this.Get("ipp");
  }
  set ipp(val) {
    this.Set("ipp", val);
  }
  get pan() {
    return this.Get("pan");
  }
  set pan(val) {
    this.Set("pan", val);
  }
  get visitNumber() {
    return this.Get("visitNumber");
  }
  set visitNumber(val) {
    this.Set("visitNumber", val);
  }
  get lastName() {
    return this.Get("lastName");
  }
  set lastName(val) {
    this.Set("lastName", val);
  }
  get legalName() {
    return this.Get("legalName");
  }
  set legalName(val) {
    this.Set("legalName", val);
  }
  get gender() {
    return this.Get("gender");
  }
  set gender(val) {
    this.Set("gender", val);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get fullTextSearch() {
    return this.Get("fullTextSearch");
  }
  set fullTextSearch(val) {
    this.Set("fullTextSearch", val);
  }
  get isDischarged() {
    return this.Get("isDischarged");
  }
  set isDischarged(val) {
    this.Set("isDischarged", val);
  }
  get age() {
    return Math.floor(((/* @__PURE__ */ new Date()).getTime() - this.birthdate.getTime()) / (1e3 * 60 * 60 * 24 * 365.25));
  }
  get unit() {
    return this.Get("unit");
  }
  set unit(val) {
    this.Set("unit", val);
  }
  get area() {
    return this.Get("area");
  }
  set area(val) {
    this.Set("area", val);
  }
  get dischargedAt() {
    return this.Get("dischargedAt");
  }
  set dischargedAt(val) {
    this.Set("dischargedAt", val);
  }
  get admittedAt() {
    return this.Get("admittedAt");
  }
  set admittedAt(val) {
    this.Set("admittedAt", val);
  }
  get ins() {
    return this.Get("ins");
  }
  set ins(val) {
    this.Set("ins", val);
  }
  get insc() {
    return this.Get("insc");
  }
  set insc(val) {
    this.Set("insc", val);
  }
  get socialSecurityNumber() {
    return this.Get("socialSecurityNumber");
  }
  set socialSecurityNumber(val) {
    this.Set("socialSecurityNumber", val);
  }
  get patient() {
    return this.Get("patient");
  }
  set patient(val) {
    this.Set("patient", val);
  }
  get createdFrom() {
    return this.Get("createdFrom");
  }
  set createdFrom(val) {
    this.Set("createdFrom", val);
  }
  get patientOutcome() {
    return this.Get("patientOutcome");
  }
  set patientOutcome(val) {
    this.Set("patientOutcome", val);
  }
  get legalFirstName() {
    return this.Get("legalFirstName");
  }
  set legalFirstName(val) {
    this.Set("legalFirstName", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("Patient", Patient);

// src/models/patient/PatientIdentity.ts
var PatientIdentity = class extends ParseClass {
  constructor(attributes) {
    super("PatientIdentity", attributes);
  }
  get ins() {
    return this.Get("ins");
  }
  set ins(val) {
    this.Set("ins", val);
  }
  get insc() {
    return this.Get("insc");
  }
  set insc(val) {
    this.Set("insc", val);
  }
  get socialSecurityNumber() {
    return this.Get("socialSecurityNumber");
  }
  set socialSecurityNumber(val) {
    this.Set("socialSecurityNumber", val);
  }
  get gender() {
    return this.Get("gender");
  }
  set gender(val) {
    this.Set("gender", val);
  }
  get firstName() {
    return this.Get("firstName");
  }
  set firstName(val) {
    this.Set("firstName", val);
  }
  get lastName() {
    return this.Get("lastName");
  }
  set lastName(val) {
    this.Set("lastName", val);
  }
  get legalName() {
    return this.Get("legalName");
  }
  set legalName(val) {
    this.Set("legalName", val);
  }
  get birthdate() {
    return this.Get("birthdate");
  }
  set birthdate(val) {
    this.Set("birthdate", val);
  }
  get birthplace() {
    return this.Get("birthplace");
  }
  set birthplace(val) {
    this.Set("birthplace", val);
  }
  get identifiers() {
    return this.Get("identifiers");
  }
  set identifiers(val) {
    this.Set("identifiers", val);
  }
  get legalFirstName() {
    return this.Get("legalFirstName");
  }
  set legalFirstName(val) {
    this.Set("legalFirstName", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("PatientIdentity", PatientIdentity);

// src/cloud/steps/createExternalTransport.ts
var externalTransportStatus = [
  "PLANNED",
  "VALIDATED",
  "IN_PROGRESS",
  "DONE",
  "CANCELED"
];
var identifierSchema = Yup15.object({
  type: Yup15.string().required(),
  value: Yup15.string().required()
});
var externalTransportPatientValidation = Yup15.object({
  birthDate: Yup15.string().required(),
  firstName: Yup15.string().required(),
  lastName: Yup15.string().required(),
  pan: Yup15.string(),
  gender: Yup15.string().oneOf(patientGender).required(),
  identifiers: Yup15.array(identifierSchema.required()).required()
});
var CreateExternalTransportValidation = Yup15.object({
  endAt: Yup15.date().required(),
  externalId: Yup15.string().required(),
  startAt: Yup15.date().required(),
  status: Yup15.string().oneOf(externalTransportStatus).required(),
  finess: Yup15.string().required(),
  farePosition: Yup15.string().oneOf(externalPatientTransportPosition).required(),
  comment: Yup15.string(),
  patient: externalTransportPatientValidation.required(),
  reason: Yup15.string()
});
var createExternalTransport = (params, options) => parse_instance_browser_default.Cloud.run(
  "create-external-transport",
  params,
  options
);

// src/cloud/steps/createPerformerRequest.ts
import * as Yup16 from "yup";
var CreatePerformerRequestValidation = Yup16.object({
  requestId: Yup16.string().required(),
  performerId: Yup16.string().required()
});
var createPerformerRequest = (params, options) => parse_instance_browser_default.Cloud.run(
  "create-performer-request",
  params,
  options
);

// src/cloud/steps/rejectPerformerRequest.ts
import * as Yup17 from "yup";
var RejectPerformerRequestValidation = Yup17.object({
  id: Yup17.string().required(),
  reason: Yup17.string()
});
var rejectPerformerRequest = (params, options) => parse_instance_browser_default.Cloud.run(
  "reject-performer-request",
  params,
  options
);

// src/cloud/steps/stepScheduling.ts
import * as Yup18 from "yup";
var StepSchedulingValidation = Yup18.object({
  unitId: Yup18.string().required(),
  startAt: Yup18.date().required(),
  endAt: Yup18.date(),
  gender: Yup18.string().oneOf(patientGender),
  age: Yup18.number(),
  specificities: Yup18.array().of(Yup18.string().oneOf(accommodationSpecificities).required())
});
var stepScheduling = (params, options) => parse_instance_browser_default.Cloud.run("step-scheduling", params, options);

// src/cloud/steps/updateExternalTransport.ts
import * as Yup19 from "yup";
var UpdateExternalTransportValidation = Yup19.object({
  endAt: Yup19.date().required(),
  externalId: Yup19.string().required(),
  startAt: Yup19.date().required(),
  status: Yup19.string().oneOf(externalTransportStatus).required(),
  farePosition: Yup19.string().oneOf(externalPatientTransportPosition),
  comment: Yup19.string(),
  reason: Yup19.string()
});
var updateExternalTransport = (params, options) => parse_instance_browser_default.Cloud.run(
  "update-external-transport",
  params,
  options
);

// src/cloud/steps/upsertAccommodation.ts
import * as Yup20 from "yup";
var UpsertAccommodationValidation = Yup20.object({
  startAt: Yup20.date().required(),
  endAt: Yup20.date(),
  isEndEstimated: Yup20.boolean().required(),
  specificities: Yup20.array(Yup20.string().oneOf(accommodationSpecificities).required()),
  practitionerIds: Yup20.array().of(Yup20.string().required()),
  bedId: Yup20.string().notRequired(),
  visitId: Yup20.string(),
  unitId: Yup20.string(),
  accommodationId: Yup20.string(),
  status: Yup20.string().oneOf(accommodationStatus),
  comment: Yup20.string().notRequired(),
  reason: Yup20.string().notRequired(),
  thesaurusItemId: Yup20.string().notRequired()
});
var upsertAccommodation = (params, options) => parse_instance_browser_default.Cloud.run(
  "upsert-accommodation",
  params,
  options
);

// src/cloud/updateThesaurusItem.ts
import * as Yup21 from "yup";
var UpdateThesaurusItemValidation = Yup21.object({
  thesaurusItemId: Yup21.string().required(),
  reason: Yup21.string(),
  expectedDurationInMinutes: Yup21.number(),
  redirectionUnitIds: Yup21.array(Yup21.string().required())
});

// src/cloud/acknowledgeFareAssignation.ts
import * as Yup22 from "yup";
var AcknowledgeFareAssignationValidation = Yup22.object({
  fareId: Yup22.string().required()
});
var acknowledgeFareAssignation = (params, options) => {
  return parse_instance_browser_default.Cloud.run("acknowledge-fare-assignation", params, options);
};
var acknowledgeFareAssignation_default = acknowledgeFareAssignation;

// src/cloud/assignFare.ts
import * as Yup23 from "yup";
var AssignFareValidation = Yup23.object({
  fareId: Yup23.string().required(),
  porterId: Yup23.string().required()
});
var assignFare = (params, options) => {
  return parse_instance_browser_default.Cloud.run("assign-fare", params, options);
};
var assignFare_default = assignFare;

// src/cloud/cancelConfirmFare.ts
import * as Yup24 from "yup";

// src/locales/fr.ts
var translations = {
  patientRequired: "Veuillez s\xE9lectionner un patient",
  unitRequired: "Veuillez s\xE9lectionner une unit\xE9",
  dateRequired: 'Veuillez s\xE9lectionner une date et une heure ou d\xE9finir la mission comme "Urgente"',
  positionRequired: "Veuillez s\xE9lectionner une position pour le transport",
  atLeastOneProperty: "Au moins une propri\xE9t\xE9 doit \xEAtre pr\xE9ciser",
  fareIdRequired: "Veuillez s\xE9lectionner un identifiant de mission",
  porterIdRequired: "Veuillez s\xE9lectionner un identifiant du brancardier",
  unitIdRequired: "Veuillez s\xE9lectionner l'identifiants de l'unit\xE9e",
  breakTypeRequired: "Veuillez s\xE9lectionner le type de pause",
  endAtMustBeAfterStartAt: "La date de fin doit \xEAtre apr\xE8s la date de d\xE9but",
  manualOccupancyCanNotBeNegative: "Le capacitaire ne peut pas \xEAtre n\xE9gatif"
};

// src/locales/index.ts
var languageMap = {
  fr_FR: translations
};
var i18n = languageMap["fr_FR"];

// src/cloud/cancelConfirmFare.ts
var CancelConfirmFareValidation = Yup24.object({
  fareId: Yup24.string().required(i18n.fareIdRequired)
});
var cancelConfirmFare = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "cancel-confirm-fare",
    params,
    options
  );
};
var cancelConfirmFare_default = cancelConfirmFare;

// src/cloud/cancelFare.ts
var cancelFare = (params, options) => {
  return parse_instance_browser_default.Cloud.run("cancel-fare", params, options);
};
var cancelFare_default = cancelFare;

// src/cloud/cancelJourney/cancelJourney.ts
import * as Yup25 from "yup";
var CancelJourneyValidation = Yup25.object({
  journeyId: Yup25.string().required()
});
var cancelJourney = (params, options) => {
  return parse_instance_browser_default.Cloud.run("cancel-journey", params, options);
};

// src/cloud/clearAnomaly.ts
import * as Yup26 from "yup";
var ClearAnomalyValidation = Yup26.object({
  anomalyId: Yup26.string().required()
});
var clearAnomaly = (params, options) => parse_instance_browser_default.Cloud.run("clear-anomaly", params, options);
var clearAnomaly_default = clearAnomaly;

// src/cloud/confirmFare.ts
import * as Yup27 from "yup";
var ConfirmFareValidation = Yup27.object({
  fareId: Yup27.string().required(i18n.fareIdRequired)
});
var confirmFare = (params, options) => {
  return parse_instance_browser_default.Cloud.run("confirm-fare", params, options);
};
var confirmFare_default = confirmFare;

// src/cloud/createFare.ts
import * as Yup28 from "yup";

// src/models/Fare.ts
var fareSpecificities = [
  "SCOP",
  // Patient sous scop
  "SAP",
  // SAP
  "OXYGEN",
  // O2
  "ON_DRIP",
  // Perfusion
  "NO_CONTACT",
  // Iso contact
  "MASK",
  // Masques
  "GLOVES",
  // Gants
  "BMR",
  // BMR,
  "BACKREST",
  // Dossier
  "APRON",
  // Tablier
  "COVID"
  // Covid-19
];
var farePositions = ["LYING_DOWN_BED", "LYING_DOWN", "SITTING_UP", "WALKING"];
var fareStatus = [
  "ASSIGNED",
  // Assignée
  "CANCELED",
  // Annulée
  "DONE",
  // Terminé
  "DRAFT",
  // Brouillon
  "FAILED",
  // Mission échouée
  "IN_PROGRESS",
  // En cours
  "PATIENT_CARE",
  // Patient pris en charge
  "PENDING",
  // En attente d'assignation
  "QUEUED",
  "STARTED",
  // Mission débutée
  "WAITING"
  // En attente d'appel ou de sortie
];
var cancellableConfirmedFareStatus = ["PENDING", "ASSIGNED", "STARTED", "PATIENT_CARE"];
var Fare = class extends ParseClass {
  constructor(attributes) {
    super("Fare", attributes);
  }
  get reference() {
    return this.Get("reference");
  }
  set reference(val) {
    this.Set("reference", val);
  }
  get wantedDate() {
    return this.Get("wantedDate");
  }
  set wantedDate(val) {
    this.Set("wantedDate", val);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get patient() {
    return this.Get("patient");
  }
  set patient(val) {
    this.Set("patient", val);
  }
  get position() {
    return this.Get("position");
  }
  set position(val) {
    this.Set("position", val);
  }
  get needUnitConfirmation() {
    return this.Get("needUnitConfirmation");
  }
  set needUnitConfirmation(val) {
    this.Set("needUnitConfirmation", val);
  }
  get fromArea() {
    return this.Get("fromArea");
  }
  set fromArea(val) {
    this.Set("fromArea", val);
  }
  get toArea() {
    return this.Get("toArea");
  }
  set toArea(val) {
    this.Set("toArea", val);
  }
  get status() {
    return this.Get("status");
  }
  set status(val) {
    this.Set("status", val);
  }
  get assignations() {
    return this.Get("assignations");
  }
  set assignations(val) {
    this.Set("assignations", val);
  }
  get incidents() {
    return this.Get("incidents");
  }
  set incidents(val) {
    this.Set("incidents", val);
  }
  get specificities() {
    return this.Get("specificities");
  }
  set specificities(val) {
    this.Set("specificities", val);
  }
  get comment() {
    return this.Get("comment");
  }
  set comment(val) {
    this.Set("comment", val);
  }
  get roundTrip() {
    return this.Get("roundTrip");
  }
  set roundTrip(val) {
    this.Set("roundTrip", val);
  }
  get createdBy() {
    return this.Get("createdBy");
  }
  set createdBy(val) {
    this.Set("createdBy", val);
  }
  get canceledAt() {
    return this.Get("canceledAt");
  }
  set canceledAt(val) {
    this.Set("canceledAt", val);
  }
  get canceledBy() {
    return this.Get("canceledBy");
  }
  set canceledBy(val) {
    this.Set("canceledBy", val);
  }
  get cancellationReason() {
    return this.Get("cancellationReason");
  }
  set cancellationReason(val) {
    this.Set("cancellationReason", val);
  }
  get lastUpdateBy() {
    return this.Get("lastUpdateBy");
  }
  set lastUpdateBy(val) {
    this.Set("lastUpdateBy", val);
  }
  get isReturnTripFromFare() {
    return this.Get("isReturnTripFromFare");
  }
  set isReturnTripFromFare(val) {
    this.Set("isReturnTripFromFare", val);
  }
  get isArchived() {
    return this.Get("isArchived");
  }
  set isArchived(val) {
    this.Set("isArchived", val);
  }
  get isEmergency() {
    return this.Get("isEmergency");
  }
  set isEmergency(val) {
    this.Set("isEmergency", val);
  }
  get scheduledAt() {
    return this.Get("scheduledAt");
  }
  set scheduledAt(val) {
    this.Set("scheduledAt", val);
  }
  get startedAt() {
    return this.Get("startedAt");
  }
  set startedAt(val) {
    this.Set("startedAt", val);
  }
  get patientCareAt() {
    return this.Get("patientCareAt");
  }
  set patientCareAt(val) {
    this.Set("patientCareAt", val);
  }
  get endedAt() {
    return this.Get("endedAt");
  }
  set endedAt(val) {
    this.Set("endedAt", val);
  }
  get duration() {
    return this.Get("duration");
  }
  set duration(val) {
    this.Set("duration", val);
  }
  get startDelay() {
    return this.Get("startDelay");
  }
  set startDelay(val) {
    this.Set("startDelay", val);
  }
  get porters() {
    return this.Get("porters");
  }
  set porters(val) {
    this.Set("porters", val);
  }
  get fromUnit() {
    return this.Get("fromUnit");
  }
  set fromUnit(val) {
    this.Set("fromUnit", val);
  }
  get toUnit() {
    return this.Get("toUnit");
  }
  set toUnit(val) {
    this.Set("toUnit", val);
  }
  get estimatedPathDurationInSeconds() {
    return this.Get("estimatedPathDurationInSeconds");
  }
  set estimatedPathDurationInSeconds(val) {
    this.Set("estimatedPathDurationInSeconds", val);
  }
  get estimatedPathDurationStrategy() {
    return this.Get("estimatedPathDurationStrategy");
  }
  set estimatedPathDurationStrategy(val) {
    this.Set("estimatedPathDurationStrategy", val);
  }
  get groupId() {
    return this.Get("groupId");
  }
  set groupId(val) {
    this.Set("groupId", val);
  }
  get procedureExternalId() {
    return this.Get("procedureExternalId");
  }
  set procedureExternalId(val) {
    this.Set("procedureExternalId", val);
  }
  get fromStep() {
    return this.Get("fromStep");
  }
  set fromStep(val) {
    this.Set("fromStep", val);
  }
  get toStep() {
    return this.Get("toStep");
  }
  set toStep(val) {
    this.Set("toStep", val);
  }
  get journey() {
    return this.Get("journey");
  }
  set journey(val) {
    this.Set("journey", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("Fare", Fare);

// src/cloud/createFare.ts
var CreateFareValidation = Yup28.object({
  patientId: Yup28.string().required(i18n.patientRequired),
  specificities: Yup28.array(Yup28.string().oneOf(fareSpecificities).required()),
  position: Yup28.string().oneOf(farePositions, i18n.positionRequired).required(i18n.positionRequired),
  comment: Yup28.string(),
  isEmergency: Yup28.boolean().required(),
  wantedDate: Yup28.date().when("isEmergency", { is: false, then: () => Yup28.date().required(i18n.dateRequired) }),
  roundTrip: Yup28.boolean(),
  fromAreaId: Yup28.string(),
  toAreaId: Yup28.string(),
  fromUnitId: Yup28.string().required(i18n.unitRequired),
  toUnitId: Yup28.string().required(i18n.unitRequired),
  isReturnTripFromFareId: Yup28.string(),
  procedureExternalId: Yup28.string(),
  needUnitConfirmation: Yup28.boolean(),
  fromStep: Yup28.object().shape({
    id: Yup28.string().required(),
    type: Yup28.string().oneOf(["accommodation", "appointment"]).required()
  }).default(void 0),
  toStep: Yup28.object().shape({
    id: Yup28.string().required(),
    type: Yup28.string().oneOf(["accommodation", "appointment"]).required()
  }).default(void 0)
});
var createFare = (params, options) => {
  return parse_instance_browser_default.Cloud.run("create-fare", params, options);
};
var createFare_default = createFare;

// src/cloud/createHealthCenter.ts
import * as Yup29 from "yup";

// src/models/HealthCenter.ts
var rorTypes = ["PACA", "BRETAGNE", "IDF"];
var delayRuleTypes = ["TODAY_AT", "TOMORROW_AT", "HOURS"];
var computeEmergencyOccupanciesOptions = ["MANUAL", "AUTO"];
var HealthCenter = class extends ParseClass {
  constructor(attributes) {
    super("HealthCenter", attributes);
  }
  get name() {
    return this.Get("name");
  }
  set name(val) {
    this.Set("name", val);
  }
  get qrCodeKey() {
    return this.Get("qrCodeKey");
  }
  set qrCodeKey(val) {
    this.Set("qrCodeKey", val);
  }
  get autodispatchActivated() {
    return this.Get("autodispatchActivated");
  }
  set autodispatchActivated(val) {
    this.Set("autodispatchActivated", val);
  }
  get autoComputeOccupanciesActivated() {
    return this.Get("autoComputeOccupanciesActivated");
  }
  set autoComputeOccupanciesActivated(val) {
    this.Set("autoComputeOccupanciesActivated", val);
  }
  get fareGroupActivated() {
    return this.Get("fareGroupActivated");
  }
  set fareGroupActivated(val) {
    this.Set("fareGroupActivated", val);
  }
  get fareGroupTimeInterval() {
    return this.Get("fareGroupTimeInterval");
  }
  set fareGroupTimeInterval(val) {
    this.Set("fareGroupTimeInterval", val);
  }
  get endOfShiftPorterActivated() {
    return this.Get("endOfShiftPorterActivated");
  }
  set endOfShiftPorterActivated(val) {
    this.Set("endOfShiftPorterActivated", val);
  }
  get portersLimitByFarePosition() {
    return this.Get("portersLimitByFarePosition");
  }
  set portersLimitByFarePosition(val) {
    this.Set("portersLimitByFarePosition", val);
  }
  get username() {
    return this.Get("username");
  }
  set username(val) {
    this.Set("username", val);
  }
  get externalCpageId() {
    return this.get("externalCpageId");
  }
  set externalCpageId(val) {
    this.set("externalCpageId", val);
  }
  getPortersLimitByFarePosition(val) {
    const portersLimitByFarePosition = this.portersLimitByFarePosition;
    if (portersLimitByFarePosition) {
      return portersLimitByFarePosition[val];
    }
  }
  get autodispatchTimeInMinutesAnticipation() {
    return this.Get("autodispatchTimeInMinutesAnticipation");
  }
  set autodispatchTimeInMinutesAnticipation(val) {
    this.Set("autodispatchTimeInMinutesAnticipation", val);
  }
  get location() {
    return this.Get("location");
  }
  set location(val) {
    this.Set("location", val);
  }
  get assigningAuthority() {
    return this.Get("assigningAuthority");
  }
  set assigningAuthority(val) {
    this.Set("assigningAuthority", val);
  }
  get isStructureDiscoveryActivated() {
    return this.Get("isStructureDiscoveryActivated");
  }
  set isStructureDiscoveryActivated(val) {
    this.Set("isStructureDiscoveryActivated", val);
  }
  get groups() {
    return this.Get("groups");
  }
  set groups(val) {
    this.Set("groups", val);
  }
  get finess() {
    return this.Get("finess");
  }
  set finess(val) {
    this.Set("finess", val);
  }
  get geoFiness() {
    return this.Get("geoFiness");
  }
  set geoFiness(val) {
    this.set("geoFiness", val);
  }
  get rorOptions() {
    return this.Get("rorOptions");
  }
  set rorOptions(val) {
    this.Set("rorOptions", val);
  }
  get computeAnomaliesActivated() {
    return this.Get("computeAnomaliesActivated");
  }
  set computeAnomaliesActivated(val) {
    this.Set("computeAnomaliesActivated", val);
  }
  get bookedBedDelayRule() {
    return this.Get("bookedBedDelayRule");
  }
  set bookedBedDelayRule(val) {
    this.Set("bookedBedDelayRule", val);
  }
  get computeEmergencyOccupancies() {
    return this.Get("computeEmergencyOccupancies");
  }
  set computeEmergencyOccupancies(val) {
    this.Set("computeEmergencyOccupancies", val);
  }
  get hasPediatricService() {
    return this.Get("hasPediatricService");
  }
  set hasPediatricService(val) {
    this.Set("hasPediatricService", val);
  }
  get autoComputeDischarge() {
    return this.Get("autoComputeDischarge");
  }
  set autoComputeDischarge(val) {
    this.Set("autoComputeDischarge", val);
  }
  get viaTrajectoireOptions() {
    return this.Get("viaTrajectoireOptions");
  }
  set viaTrajectoireOptions(val) {
    this.Set("viaTrajectoireOptions", val);
  }
  get chatSupportEnabled() {
    return this.Get("chatSupportEnabled");
  }
  set chatSupportEnabled(val) {
    this.Set("chatSupportEnabled", val);
  }
  get patientTransportEnabled() {
    return this.Get("patientTransportEnabled");
  }
  set patientTransportEnabled(val) {
    this.Set("patientTransportEnabled", val);
  }
  get thesaurusEnabled() {
    return this.Get("thesaurusEnabled");
  }
  set thesaurusEnabled(val) {
    this.Set("thesaurusEnabled", val);
  }
  get thesaurusReasonEnabled() {
    return this.Get("thesaurusReasonEnabled");
  }
  set thesaurusReasonEnabled(val) {
    this.Set("thesaurusReasonEnabled", val);
  }
  get thesaurusUnitsSuggestionsEnabled() {
    return this.Get("thesaurusUnitsSuggestionsEnabled");
  }
  set thesaurusUnitsSuggestionsEnabled(val) {
    this.Set("thesaurusUnitsSuggestionsEnabled", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("HealthCenter", HealthCenter);

// src/cloud/createHealthCenter.ts
var HealthCenterGroupValidationSchema = Yup29.object({
  name: Yup29.string().required()
});
var CreateHealthCenterValidation = Yup29.object({
  name: Yup29.string().required(),
  endOfShiftPorterActivated: Yup29.boolean(),
  fareGroupActivated: Yup29.boolean(),
  username: Yup29.string(),
  externalCpageId: Yup29.string(),
  fareGroupTimeInterval: Yup29.number(),
  location: Yup29.object().optional().default(void 0).shape({
    longitude: Yup29.number().required(),
    latitude: Yup29.number().required()
  }),
  autodispatchActivated: Yup29.boolean(),
  autoComputeOccupanciesActivated: Yup29.boolean(),
  autodispatchTimeInMinutesAnticipation: Yup29.number(),
  groups: Yup29.array().optional().of(HealthCenterGroupValidationSchema.required()),
  finess: Yup29.string(),
  assigningAuthority: Yup29.string(),
  rorOptions: Yup29.object({
    username: Yup29.string(),
    isActivated: Yup29.boolean(),
    affiliatedRor: Yup29.string().oneOf(rorTypes),
    receiverEmail: Yup29.string().email()
  }),
  computeAnomaliesActivated: Yup29.boolean(),
  bookedBedDelayRule: Yup29.object().shape({
    type: Yup29.string().oneOf(delayRuleTypes).required(),
    value: Yup29.number().required()
  }).default(void 0),
  computeEmergencyOccupancies: Yup29.string().oneOf(computeEmergencyOccupanciesOptions),
  autoComputeDischarge: Yup29.boolean()
});
var createHealthCenter = (params) => {
  return parse_instance_browser_default.Cloud.run(
    "create-health-center",
    params,
    {
      useMasterKey: true
    }
  );
};
var createHealthCenter_default = createHealthCenter;

// src/cloud/createHealthCenterMapping.ts
import * as Yup30 from "yup";
var CreateHealthCenterMappingValidation = Yup30.object({
  healthCenterId: Yup30.string().required(),
  url: Yup30.string().url().required()
});
var createHealthCenterMapping = (params) => {
  return parse_instance_browser_default.Cloud.run("create-health-center-mapping", params, {
    useMasterKey: true
  });
};
var createHealthCenterMapping_default = createHealthCenterMapping;

// src/cloud/createHealthCenterMappingFromJSON.ts
import * as Yup31 from "yup";

// src/models/Area.ts
var externalTypeCodes = ["hospital", "unit", "service", "room", "bed"];
var availabilityPeriodStatus = ["ACTIVE", "INACTIVE"];
var Area = class extends ParseClass {
  constructor(attributes) {
    super("Area", attributes);
  }
  get name() {
    return this.Get("name");
  }
  set name(val) {
    this.Set("name", val);
  }
  get parent() {
    return this.Get("parent");
  }
  set parent(val) {
    this.Set("parent", val);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get isSearchable() {
    return this.Get("isSearchable");
  }
  set isSearchable(val) {
    this.Set("isSearchable", val);
  }
  get children() {
    return this.Get("children");
  }
  set children(val) {
    this.Set("children", val);
  }
  get externalIds() {
    return this.Get("externalIds");
  }
  set externalIds(val) {
    this.Set("externalIds", val);
  }
  get externalTypeCode() {
    return this.Get("externalTypeCode");
  }
  set externalTypeCode(val) {
    this.Set("externalTypeCode", val);
  }
  get availabilityPeriods() {
    return this.Get("availabilityPeriods");
  }
  set availabilityPeriods(val) {
    this.Set("availabilityPeriods", val);
  }
  get nextSlotAt() {
    return this.Get("nextSlotAt");
  }
  set nextSlotAt(val) {
    this.Set("nextSlotAt", val);
  }
  get basedOn() {
    return this.Get("basedOn");
  }
  set basedOn(val) {
    this.Set("basedOn", val);
  }
  get excludedFromOccupancy() {
    return this.Get("excludedFromOccupancy");
  }
  set excludedFromOccupancy(val) {
    this.Set("excludedFromOccupancy", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("Area", Area);

// src/cloud/createHealthCenterMappingFromJSON.ts
var LocationValidationSchema = Yup31.object({
  id: Yup31.string().required(),
  name: Yup31.string().required(),
  partOf: Yup31.string(),
  type: Yup31.string().oneOf(externalTypeCodes)
}).required();
var CreateHealthCenterMappingFromJSONValidation = Yup31.object({
  healthCenterId: Yup31.string().required(),
  json: Yup31.array().of(LocationValidationSchema.required()).required()
});
var createHealthCenterMappingFromJSON = (params) => {
  return parse_instance_browser_default.Cloud.run(
    "create-health-center-mapping-from-json",
    params,
    {
      useMasterKey: true
    }
  );
};
var createHealthCenterMappingFromJSON_default = createHealthCenterMappingFromJSON;

// src/cloud/createIncident.ts
import * as Yup32 from "yup";

// src/models/Incident.ts
var incidentReasons = [
  "PATIENT_UNFIT",
  "PATIENT_NOT_READY",
  "INADEQUATE_FARE_TRANSPORT",
  "NEED_HELP",
  "OTHER",
  "PATIENT_MISSING"
];
var Incident = class extends ParseClass {
  constructor(attributes) {
    super("Incident", attributes);
  }
  get fare() {
    return this.Get("fare");
  }
  set fare(val) {
    this.Set("fare", val);
  }
  get createdBy() {
    return this.Get("createdBy");
  }
  set createdBy(val) {
    this.Set("createdBy", val);
  }
  get porter() {
    return this.Get("porter");
  }
  set porter(val) {
    this.Set("porter", val);
  }
  get reason() {
    return this.Get("reason");
  }
  set reason(val) {
    this.Set("reason", val);
  }
  get comment() {
    return this.Get("comment");
  }
  set comment(val) {
    this.Set("comment", val);
  }
  get delayInMinutes() {
    return this.Get("delayInMinutes");
  }
  set delayInMinutes(val) {
    this.Set("delayInMinutes", val);
  }
  get createdByRole() {
    return this.Get("createdByRole");
  }
  set createdByRole(val) {
    this.Set("createdByRole", val);
  }
  get createdByName() {
    return this.Get("createdByName");
  }
  set createdByName(val) {
    this.Set("createdByName", val);
  }
  get adequateTransport() {
    return this.Get("adequateTransport");
  }
  set adequateTransport(val) {
    this.Set("adequateTransport", val);
  }
  get helpRequired() {
    return this.Get("helpRequired");
  }
  set helpRequired(val) {
    this.Set("helpRequired", val);
  }
  get unassignmentRequested() {
    return this.Get("unassignmentRequested");
  }
  set unassignmentRequested(val) {
    this.Set("unassignmentRequested", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("Incident", Incident);

// src/cloud/createIncident.ts
var CreateIncidentValidation = Yup32.object({
  fareId: Yup32.string().required(),
  reason: Yup32.string().oneOf(incidentReasons).required(),
  comment: Yup32.string(),
  delayInMinutes: Yup32.number(),
  adequateTransport: Yup32.string().oneOf(farePositions),
  helpRequired: Yup32.number(),
  unassignmentRequested: Yup32.boolean()
});
var createIncident = (params, options) => {
  return parse_instance_browser_default.Cloud.run("create-incident", params, options);
};
var createIncident_default = createIncident;

// src/cloud/createJourney/createJourney.ts
import * as Yup33 from "yup";
var CreateJourneyStepValidation = Yup33.object({
  toUnitId: Yup33.string().required(i18n.unitRequired),
  toAreaId: Yup33.string(),
  wantedDate: Yup33.date().required(i18n.dateRequired)
});
var CreateJourneyValidation = Yup33.object({
  patientId: Yup33.string().required(i18n.patientRequired),
  roundTrip: Yup33.boolean().required(),
  position: Yup33.string().oneOf(farePositions).required(i18n.positionRequired),
  comment: Yup33.string(),
  isEmergency: Yup33.boolean(),
  specificities: Yup33.array().of(Yup33.string().oneOf(fareSpecificities).required()),
  fromUnitId: Yup33.string().required(i18n.unitRequired),
  fromAreaId: Yup33.string(),
  steps: Yup33.array().of(CreateJourneyStepValidation.required()).required()
});
var createJourney = (params, options) => {
  return parse_instance_browser_default.Cloud.run("create-journey", params, options);
};

// src/cloud/createPathDefaultTime.ts
import * as Yup34 from "yup";
var CreatePathDefaultTimeValidation = Yup34.object({
  fromAreaId: Yup34.string().required(),
  toAreaId: Yup34.string().required(),
  durationInSeconds: Yup34.number().required(),
  weight: Yup34.number().required(),
  position: Yup34.string().oneOf(farePositions).required()
});
var pathDefaultTime = (params) => {
  return parse_instance_browser_default.Cloud.run(
    "create-path-default-time",
    params,
    {
      useMasterKey: true
    }
  );
};
var createPathDefaultTime_default = pathDefaultTime;

// src/cloud/createPractitioner/createPractitioner.ts
import * as Yup35 from "yup";
var CreatePractitionerValidation = Yup35.object({
  firstName: Yup35.string().required(),
  lastName: Yup35.string().required(),
  unitId: Yup35.string().required(),
  color: Yup35.string()
});
var createPractitioner = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "create-practitioner",
    params,
    options
  );
};

// src/cloud/dispatchFare.ts
var dispatchFare = (params, options) => {
  return parse_instance_browser_default.Cloud.run("dispatch-fare", params, options);
};
var dispatchFare_default = dispatchFare;

// src/cloud/emergencyOccupancy/getHealthCenterEmergencyOccupancies.ts
import * as Yup36 from "yup";
var GetHealthCenterEmergencyOccupanciesValidation = Yup36.object({
  healthCenter: Yup36.string().required()
});
var getHealthCenterEmergencyOccupancies = (params, options) => {
  return parse_instance_browser_default.Cloud.run("get-healthcenter-emergency-occupancies", params, options);
};
var getHealthCenterEmergencyOccupancies_default = getHealthCenterEmergencyOccupancies;

// src/cloud/emergencyOccupancy/updateEmergencyOccupancy.ts
import * as Yup37 from "yup";

// src/models/EmergencyOccupancy.ts
var emergencyOccupancyKey = ["VIVALTO_API", "9H", "14H", "17H"];
var emergencyOccupancyService = ["adults", "pediatric"];
var EmergencyOccupancy = class extends ParseClass {
  constructor(attributes) {
    super("EmergencyOccupancy", attributes);
  }
  get key() {
    return this.Get("key");
  }
  set key(value) {
    this.Set("key", value);
  }
  get date() {
    return this.Get("date");
  }
  set date(value) {
    this.Set("date", value);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(value) {
    this.Set("healthCenter", value);
  }
  get service() {
    return this.Get("service");
  }
  set service(value) {
    this.Set("service", value);
  }
  get averageWaitingTime() {
    return this.Get("averageWaitingTime");
  }
  set averageWaitingTime(value) {
    this.Set("averageWaitingTime", value);
  }
  get waitingPatients() {
    return this.Get("waitingPatients");
  }
  set waitingPatients(value) {
    this.Set("waitingPatients", value);
  }
  get currentPatients() {
    return this.Get("currentPatients");
  }
  set currentPatients(value) {
    this.Set("currentPatients", value);
  }
  get availableBeds() {
    return this.Get("availableBeds");
  }
  set availableBeds(value) {
    this.Set("availableBeds", value);
  }
  get waitingPatientsBySector() {
    return this.Get("waitingPatientsBySector");
  }
  set waitingPatientsBySector(value) {
    this.Set("waitingPatientsBySector", value);
  }
  get comment() {
    return this.Get("comment");
  }
  set comment(value) {
    this.Set("comment", value);
  }
};
parse_instance_browser_default.Object.registerSubclass("EmergencyOccupancy", EmergencyOccupancy);

// src/cloud/emergencyOccupancy/updateEmergencyOccupancy.ts
var UpdateEmergencyOccupancyValidation = Yup37.object({
  key: Yup37.string().oneOf(emergencyOccupancyKey).required(),
  healthCenterId: Yup37.string().required(),
  service: Yup37.string().oneOf(emergencyOccupancyService).required(),
  averageWaitingTime: Yup37.number().integer(),
  waitingPatients: Yup37.number().integer(),
  currentPatients: Yup37.number().integer().required(),
  availableBeds: Yup37.number().integer(),
  waitingPatientsBySector: Yup37.object({
    Chirurgie: Yup37.number().integer(),
    M\u00E9decine: Yup37.number().integer(),
    Obst\u00E9trique: Yup37.number().integer(),
    P\u00E9diatrie: Yup37.number().integer(),
    R\u00E9animation: Yup37.number().integer(),
    PSY: Yup37.number().integer(),
    SMR: Yup37.number().integer(),
    Urgences: Yup37.number().integer()
  }),
  comment: Yup37.string()
});
var updateEmergencyOccupancy = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "update-emergency-occupancy",
    params,
    options
  );
};
var updateEmergencyOccupancy_default = updateEmergencyOccupancy;

// src/cloud/fareTick.ts
var fareTick = (params, options) => {
  return parse_instance_browser_default.Cloud.run("fare-tick", params, options);
};
var fareTick_default = fareTick;

// src/cloud/getOverviewStatistics.ts
import * as Yup38 from "yup";
var GetOverviewStatisticsValidation = Yup38.object({
  startDate: Yup38.date().required(),
  endDate: Yup38.date().required(),
  healthCenterId: Yup38.string().required()
});
var getOverviewStatistics = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "get-overview-statistics",
    params,
    options
  );
};
var getOverviewStatistics_default = getOverviewStatistics;

// src/cloud/getPorters.ts
import * as Yup39 from "yup";
var GetPortersValidation = Yup39.object({
  qrCodeKey: Yup39.string().required(),
  healthCenterId: Yup39.string().required()
});
var getPorters = (params, options) => {
  return parse_instance_browser_default.Cloud.run("get-porters", params, options);
};
var getPorters_default = getPorters;

// src/cloud/importThesaurus.ts
import * as Yup40 from "yup";
var ImportThesaurusValidation = Yup40.object({
  file: Yup40.string().required(),
  healthCenterId: Yup40.string().required()
});
var importThesaurus = (params, options) => {
  return parse_instance_browser_default.Cloud.run("import-thesaurus", params, options);
};
var importThesaurus_default = importThesaurus;

// src/cloud/leaveBreak.ts
var leaveBreak = (options) => {
  return parse_instance_browser_default.Cloud.run("leave-break", null, options);
};
var leaveBreak_default = leaveBreak;

// src/cloud/logoutPorter.ts
import * as Yup41 from "yup";
var LogoutPorterValidation = Yup41.object({
  porterId: Yup41.string()
});
var logoutPorter = (params, options) => {
  return parse_instance_browser_default.Cloud.run("logout-porter", params, options);
};
var logoutPorter_default = logoutPorter;

// src/cloud/notifications/acknowledgeNotification.ts
import * as Yup42 from "yup";
var AcknowledgeNotificationValidation = Yup42.object({
  notificationId: Yup42.string().required()
});
var acknowledgeNotification = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "acknowledge-notification",
    params,
    options
  );
};
var acknowledgeNotification_default = acknowledgeNotification;

// src/cloud/notifications/notificationStats.ts
import * as Yup43 from "yup";
var notifsMepDate = /* @__PURE__ */ new Date("2022-04-14");
var NotificationStatsValidation = Yup43.object({
  startAt: Yup43.date().required().min(notifsMepDate).default(subMonths(/* @__PURE__ */ new Date(), 1) > notifsMepDate ? subMonths(/* @__PURE__ */ new Date(), 1) : notifsMepDate),
  endAt: Yup43.date().min(notifsMepDate).when("startAt", ([startAt], schema) => {
    return schema.max(addMonths(new Date(startAt), 1));
  }).required().default(/* @__PURE__ */ new Date())
});
var notificationStats = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "notifications-stats",
    params,
    options
  );
};
var notificationStats_default = notificationStats;

// src/cloud/notifications/readAllNotifications.ts
import * as Yup44 from "yup";
var ReadAllNotificationsValidation = Yup44.object({
  notificationIds: Yup44.array(Yup44.string().required()).required()
});
var acknowledgeNotification2 = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "read-all-notifications",
    params,
    options
  );
};
var readAllNotifications_default = acknowledgeNotification2;

// src/cloud/notifications/unreadNotification.ts
import * as Yup45 from "yup";
var UnreadNotificationValidation = Yup45.object({
  id: Yup45.string().required()
});
var unreadNotification = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "unread-notification",
    params,
    options
  );
};
var unreadNotification_default = unreadNotification;

// src/cloud/patientMovments/createPartialPatient.ts
import * as Yup46 from "yup";
var CreatePartialPatientValidation = Yup46.object({
  gender: Yup46.mixed().required(),
  firstName: Yup46.string().required(),
  lastName: Yup46.string().required(),
  legalName: Yup46.string(),
  legalFirstName: Yup46.string(),
  birthdate: Yup46.date().required(),
  ipp: Yup46.string(),
  pan: Yup46.string(),
  healthCenterId: Yup46.string(),
  createdFrom: Yup46.string().oneOf(patientCreationSources)
});
var createPartialPatient = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "create-partial-patient",
    params,
    options
  );
};
var createPartialPatient_default = createPartialPatient;

// src/cloud/refreshVisit.ts
import * as Yup47 from "yup";
var RefreshVisitValidation = Yup47.object({
  visitId: Yup47.string().required()
});
var refreshVisit = (params, options) => {
  return parse_instance_browser_default.Cloud.run("refresh-visit", params, options);
};
var refreshVisit_default = refreshVisit;

// src/cloud/removeFareAssignation.ts
import * as Yup48 from "yup";
var RemoveFareAssignationValidation = Yup48.object({
  fareId: Yup48.string().required(),
  porterId: Yup48.string().required(),
  fareAssignationId: Yup48.string().required()
});
var removeFareAssignation = (params, options) => {
  return parse_instance_browser_default.Cloud.run("remove-fare-assignation", params, options);
};
var removeFareAssignation_default = removeFareAssignation;

// src/cloud/removePractitioner/removePractitioner.ts
import * as Yup49 from "yup";
var RemovePractitionerValidation = Yup49.object({
  id: Yup49.string().required()
});
var removePractitioner = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "remove-practitioner",
    params,
    options
  );
};

// src/cloud/resetPorterAfterLogout.ts
import * as Yup50 from "yup";
var ResetPorterAfterLogoutValidation = Yup50.object({
  porterId: Yup50.string().required()
});
var resetPorterAfterLogout = (params) => {
  return parse_instance_browser_default.Cloud.run(
    "reset-porter-after-logout",
    params,
    {
      useMasterKey: true
    }
  );
};
var resetPorterAfterLogout_default = resetPorterAfterLogout;

// src/cloud/setConfigVersion.ts
import * as Yup51 from "yup";
var SetConfigVersionValidation = Yup51.object({
  version: Yup51.string().required(),
  forceUpdate: Yup51.boolean()
});
var setConfigVersion = (params) => {
  return parse_instance_browser_default.Cloud.run("set-config-version", params, {
    useMasterKey: true
  });
};
var setConfigVersion_default = setConfigVersion;

// src/cloud/setPorterUnits.ts
import * as Yup52 from "yup";
var SetPorterUnitsValidation = Yup52.object({
  porterId: Yup52.string().required(i18n.porterIdRequired),
  unitIds: Yup52.array(Yup52.string().required(i18n.unitIdRequired))
});
var setPorterUnits = (params, options) => {
  return parse_instance_browser_default.Cloud.run("set-porter-units", params, options);
};
var setPorterUnits_default = setPorterUnits;

// src/cloud/structure/closeMultipleBeds.ts
import * as Yup53 from "yup";
var CloseMultipleBedsValidation = Yup53.object({
  areaIds: Yup53.array(Yup53.string().required()).required(),
  startAt: Yup53.date().required(),
  endAt: Yup53.date().min(Yup53.ref("startAt"), i18n.endAtMustBeAfterStartAt),
  comment: Yup53.string(),
  specificities: Yup53.array(Yup53.string().oneOf(accommodationSpecificities).required())
});
var closeMultipleBeds = (params, options) => parse_instance_browser_default.Cloud.run("close-multiple-beds", params, options);
var closeMultipleBeds_default = closeMultipleBeds;

// src/cloud/structure/createArea.ts
import * as Yup54 from "yup";
var AvailabilityPeriodValidation = Yup54.object({
  start: Yup54.date().required(),
  end: Yup54.date().required(),
  status: Yup54.string().oneOf(availabilityPeriodStatus).required()
});
var CreateAreaValidation = Yup54.object({
  name: Yup54.string().required(),
  healthCenterId: Yup54.string().required(),
  externalTypeCode: Yup54.string().oneOf(externalTypeCodes),
  parentId: Yup54.string(),
  externalIds: Yup54.array(Yup54.string().required()),
  isSearchable: Yup54.boolean(),
  availabilityPeriods: Yup54.array().of(AvailabilityPeriodValidation.required()),
  excludedFromOccupancy: Yup54.boolean()
});
var createArea = (params, options) => {
  return parse_instance_browser_default.Cloud.run("create-area", params, options);
};
var createArea_default = createArea;

// src/cloud/structure/createUnit.ts
import * as Yup56 from "yup";

// src/models/Unit.ts
var unitTypes = ["MEDICAL", "ACCOMMODATION", "OTHER", "EMERGENCY"];
var Unit = class extends ParseClass {
  constructor(attributes) {
    super("Unit", attributes);
  }
  get name() {
    return this.Get("name");
  }
  set name(val) {
    this.Set("name", val);
  }
  get areas() {
    return this.Get("areas");
  }
  set areas(val) {
    this.Set("areas", val);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get requestFareConfirmation() {
    return this.Get("requestFareConfirmation");
  }
  set requestFareConfirmation(val) {
    this.Set("requestFareConfirmation", val);
  }
  get externalId() {
    return this.Get("externalId");
  }
  set externalId(val) {
    this.Set("externalId", val);
  }
  get department() {
    return this.Get("department");
  }
  set department(val) {
    this.Set("department", val);
  }
  get externalTypeCode() {
    return this.Get("externalTypeCode");
  }
  set externalTypeCode(val) {
    this.Set("externalTypeCode", val);
  }
  get type() {
    return this.Get("type");
  }
  set type(val) {
    this.Set("type", val);
  }
  get defaultFarePositionFromThis() {
    return this.Get("defaultFarePositionFromThis");
  }
  set defaultFarePositionFromThis(val) {
    this.Set("defaultFarePositionFromThis", val);
  }
  get occupancy() {
    return this.Get("occupancy");
  }
  set occupancy(val) {
    this.Set("occupancy", val);
  }
  get contacts() {
    return this.Get("contacts");
  }
  set contacts(val) {
    this.Set("contacts", val);
  }
  get specialties() {
    return this.get("specialties");
  }
  set specialties(value) {
    this.set("specialties", value);
  }
  get autoComputeOccupanciesActivated() {
    return this.Get("autoComputeOccupanciesActivated");
  }
  set autoComputeOccupanciesActivated(val) {
    this.Set("autoComputeOccupanciesActivated", val);
  }
  get responsibleUnits() {
    return this.Get("responsibleUnits");
  }
  set responsibleUnits(val) {
    this.Set("responsibleUnits", val);
  }
  get autoComputeDischarge() {
    return this.Get("autoComputeDischarge");
  }
  set autoComputeDischarge(val) {
    this.Set("autoComputeDischarge", val);
  }
  get isEmergency() {
    return this.Get("isEmergency");
  }
  set isEmergency(val) {
    this.Set("isEmergency", val);
  }
  get manualOccupancyActivated() {
    return this.Get("manualOccupancyActivated");
  }
  set manualOccupancyActivated(val) {
    this.Set("manualOccupancyActivated", val);
  }
  get manualOccupancy() {
    return this.Get("manualOccupancy");
  }
  set manualOccupancy(val) {
    this.Set("manualOccupancy", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("Unit", Unit);

// src/models/UnitSpecialty.ts
var sectors = [
  "Chirurgie",
  "M\xE9decine",
  "Obst\xE9trique",
  "R\xE9animation",
  "Urgences",
  "SMR",
  "PSY",
  "P\xE9diatrie",
  "HAD"
];
var specialties = [
  "Chirurgie cardiaque",
  "Chirurgie cervico-faciale",
  "Chirurgie g\xE9n\xE9rale",
  "Chirurgie infantile",
  "Chirurgie maxillo-faciale et stomatologie",
  "Chirurgie orthop\xE9dique et traumatologie",
  "Chirurgie plastique",
  "Chirurgie thoracique et cardio-vasculaire",
  "Chirurgie urologique",
  "Chirurgie vasculaire",
  "Chirurgie visc\xE9rale et digestive",
  "Neurochirurgie",
  "Addictologie",
  "Allergologie et immunologie",
  "Anatomie et Cytologie pathologiques",
  "Anesth\xE9sie",
  "Biologie m\xE9dicale",
  "Br\xFBlologie",
  "Cardiologie",
  "Dermatologie",
  "Endocrinologie et m\xE9tabolisme",
  "H\xE9pato-Gastro-Ent\xE9rologie",
  "G\xE9n\xE9tique",
  "G\xE9riatrie",
  "HAD",
  "H\xE9matologie",
  "Imagerie m\xE9dicale",
  "Maladies infectieuses",
  "Maladies tropicales",
  "M\xE9decine a\xE9rospatiale-a\xE9ronautique",
  "M\xE9decine du sport",
  "M\xE9decine du travail",
  "M\xE9decine g\xE9n\xE9rale",
  "M\xE9decine hyperbare",
  "M\xE9decine interne",
  "M\xE9decine l\xE9gale",
  "M\xE9decine nucl\xE9aire",
  "M\xE9decine p\xE9nitentiaire",
  "M\xE9decine polyvalente",
  "M\xE9decine vasculaire, angiologie, phl\xE9bologie",
  "N\xE9phrologie",
  "Neurologie",
  "Neuropediatrie",
  "Oncologie",
  "Ophtalmologie",
  "ORL",
  "P\xE9diatrie",
  "Pneumologie",
  "Rhumatologie",
  "Sant\xE9 publique et M\xE9decine sociale",
  "Soins palliatifs",
  "Transfusion",
  "Gyn\xE9cologie-obst\xE9trique",
  "N\xE9onatologie",
  "Maternit\xE9",
  "UHCD",
  "Urgences",
  "M\xE9decine physique et de r\xE9adaptation adulte",
  "M\xE9decine physique et de r\xE9adaptation enfant",
  "Soins de suite sp\xE9cialis\xE9s et polyvalents",
  "R\xE9animation polyvalente",
  "USC - Unit\xE9 de Surveillance Continue",
  "USI - Unit\xE9 de Soins Intensifs",
  "P\xE9dopsychiatrie",
  "Neuropsychiatrie",
  "Psychiatrie",
  "Court s\xE9jour g\xE9riatrique"
];
var specialtiesBySector = {
  Chirurgie: [
    "Chirurgie cardiaque",
    "Chirurgie cervico-faciale",
    "Chirurgie g\xE9n\xE9rale",
    "Chirurgie infantile",
    "Chirurgie maxillo-faciale et stomatologie",
    "Chirurgie orthop\xE9dique et traumatologie",
    "Chirurgie plastique",
    "Chirurgie thoracique et cardio-vasculaire",
    "Chirurgie urologique",
    "Chirurgie vasculaire",
    "Chirurgie visc\xE9rale et digestive",
    "Neurochirurgie"
  ],
  M\u00E9decine: [
    "Addictologie",
    "Allergologie et immunologie",
    "Anatomie et Cytologie pathologiques",
    "Anesth\xE9sie",
    "Biologie m\xE9dicale",
    "Br\xFBlologie",
    "Cardiologie",
    "Dermatologie",
    "Endocrinologie et m\xE9tabolisme",
    "H\xE9pato-Gastro-Ent\xE9rologie",
    "G\xE9n\xE9tique",
    "G\xE9riatrie",
    "H\xE9matologie",
    "Imagerie m\xE9dicale",
    "Maladies infectieuses",
    "Maladies tropicales",
    "M\xE9decine a\xE9rospatiale-a\xE9ronautique",
    "M\xE9decine du sport",
    "M\xE9decine du travail",
    "M\xE9decine g\xE9n\xE9rale",
    "M\xE9decine hyperbare",
    "M\xE9decine interne",
    "M\xE9decine l\xE9gale",
    "M\xE9decine nucl\xE9aire",
    "M\xE9decine p\xE9nitentiaire",
    "M\xE9decine polyvalente",
    "M\xE9decine vasculaire, angiologie, phl\xE9bologie",
    "N\xE9phrologie",
    "Neurologie",
    "Neuropediatrie",
    "Oncologie",
    "Ophtalmologie",
    "ORL",
    "P\xE9diatrie",
    "Pneumologie",
    "Rhumatologie",
    "Sant\xE9 publique et M\xE9decine sociale",
    "Soins palliatifs",
    "Transfusion",
    "Court s\xE9jour g\xE9riatrique"
  ],
  Obst\u00E9trique: ["Gyn\xE9cologie-obst\xE9trique", "N\xE9onatologie", "Maternit\xE9"],
  Urgences: ["UHCD", "Urgences"],
  SMR: [
    "M\xE9decine physique et de r\xE9adaptation adulte",
    "M\xE9decine physique et de r\xE9adaptation enfant",
    "Soins de suite sp\xE9cialis\xE9s et polyvalents"
  ],
  R\u00E9animation: ["R\xE9animation polyvalente", "USC - Unit\xE9 de Surveillance Continue", "USI - Unit\xE9 de Soins Intensifs"],
  PSY: ["P\xE9dopsychiatrie", "Neuropsychiatrie", "Psychiatrie"],
  P\u00E9diatrie: [],
  HAD: ["HAD"]
};
var getSpecialtiesBySectors = (sectors2) => {
  const specialties2 = /* @__PURE__ */ new Set();
  sectors2.forEach((sector) => {
    const sectorSpecialties = getSpecialtiesBySector(sector);
    sectorSpecialties.forEach((sectorSpecialty) => specialties2.add(sectorSpecialty));
  });
  return Array.from(specialties2);
};
var getSpecialtiesBySector = (sector) => {
  return specialtiesBySector[sector];
};
var getSectorBySpecialty = (specialty) => {
  for (const key in specialtiesBySector) {
    const sector = key;
    const sectorSpecialities = specialtiesBySector[sector];
    if (sectorSpecialities.includes(specialty)) {
      return sector;
    }
  }
  throw new Error(`No sector found for speciality ${specialty}`);
};
var getSectorsBySpecialties = (specialties2 = []) => {
  return Array.from(new Set(specialties2.map(getSectorBySpecialty).filter((specialty) => specialty !== void 0)));
};

// src/cloud/shared/contact.ts
import * as Yup55 from "yup";

// src/models/shared/contact.ts
var contactPointSystems = ["phone", "fax", "email", "url", "pager", "sms", "other"];
var contactPointUses = ["home", "work", "mobile", "temp", "old"];

// src/cloud/shared/contact.ts
var ContactPointValidation = Yup55.object({
  system: Yup55.string().required().oneOf(contactPointSystems),
  value: Yup55.string().required(),
  use: Yup55.string().oneOf(contactPointUses).optional()
});
var ContactValidation = Yup55.object({
  name: Yup55.string().required(),
  telecoms: Yup55.array().required().of(ContactPointValidation.required())
});

// src/cloud/structure/createUnit.ts
var UnitManualOccupancyValidation = Yup56.object({
  open: Yup56.number().required()
});
var CreateUnitValidation = Yup56.object({
  name: Yup56.string().required(),
  areaIds: Yup56.array(Yup56.string().required()),
  healthCenterId: Yup56.string().required(),
  requestFareConfirmation: Yup56.boolean(),
  type: Yup56.string().oneOf(unitTypes),
  externalId: Yup56.string(),
  department: Yup56.string(),
  specialties: Yup56.array(Yup56.string().oneOf(specialties).required()),
  defaultFarePositionFromThis: Yup56.string().oneOf(farePositions),
  contacts: Yup56.array().of(ContactValidation.required()),
  autoComputeOccupanciesActivated: Yup56.boolean(),
  responsibleUnits: Yup56.array(Yup56.string().required()),
  autoComputeDischarge: Yup56.boolean(),
  isEmergency: Yup56.boolean(),
  manualOccupancyActivated: Yup56.boolean(),
  manualOccupancy: UnitManualOccupancyValidation.default(void 0)
});
var createUnit = (params, options) => {
  return parse_instance_browser_default.Cloud.run("create-unit", params, options);
};
var createUnit_default = createUnit;

// src/cloud/structure/deleteArea.ts
import * as Yup57 from "yup";
var DeleteAreaValidation = Yup57.object({
  id: Yup57.string().required()
});
var deleteArea = (params, options) => {
  return parse_instance_browser_default.Cloud.run("delete-area", params, options);
};
var deleteArea_default = deleteArea;

// src/cloud/structure/getHealthCenterGroups.ts
var getHealthCenterGroups = (options) => {
  return parse_instance_browser_default.Cloud.run("get-healthcenter-groups", null, options);
};
var getHealthCenterGroups_default = getHealthCenterGroups;

// src/cloud/structure/importStructure.ts
import * as Yup58 from "yup";
var ImportStructureValidation = Yup58.object({
  healthCenterId: Yup58.string().required(),
  url: Yup58.string().required()
});
var importStructure = (params, options) => {
  return parse_instance_browser_default.Cloud.run("import-structure", params, options);
};
var importStructure_default = importStructure;

// src/cloud/structure/moveArea.ts
import * as Yup59 from "yup";
var MoveAreaValidation = Yup59.object({
  id: Yup59.string().required(),
  parentId: Yup59.string().required(),
  newExternalIds: Yup59.array(Yup59.string().required()),
  activationDate: Yup59.date()
});
var moveArea = (params, options) => {
  return parse_instance_browser_default.Cloud.run("move-area", params, options);
};
var moveArea_default = moveArea;

// src/cloud/structure/updateArea.ts
import * as Yup60 from "yup";
var UpdateAreaValidation = Yup60.object({
  id: Yup60.string().required(),
  name: Yup60.string(),
  healthCenterId: Yup60.string(),
  externalTypeCode: Yup60.string().oneOf(externalTypeCodes),
  parentId: Yup60.string(),
  externalIds: Yup60.array(Yup60.string().required()),
  isSearchable: Yup60.boolean(),
  excludedFromOccupancy: Yup60.boolean(),
  availabilityPeriods: Yup60.array().of(AvailabilityPeriodValidation.required())
});
var updateArea = (params, options) => {
  return parse_instance_browser_default.Cloud.run("update-area", params, options);
};
var updateArea_default = updateArea;

// src/cloud/structure/updateAreaAvailabilityPeriods.ts
import * as Yup61 from "yup";
var UpdateAreaAvailabilityPeriodsValidation = Yup61.object({
  id: Yup61.string().required(),
  start: Yup61.date(),
  end: Yup61.date(),
  status: Yup61.string().oneOf(availabilityPeriodStatus).required()
});
var updateAreaAvailabilityPeriods = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "update-area-availability-periods",
    params,
    options
  );
};
var updateAreaAvailabilityPeriods_default = updateAreaAvailabilityPeriods;

// src/cloud/structure/updateHealthCenter.ts
import * as Yup62 from "yup";
var rorOptionsValidationSchema = Yup62.object({
  username: Yup62.string(),
  isActivated: Yup62.boolean(),
  affiliatedRor: Yup62.string().oneOf(rorTypes),
  receiverEmail: Yup62.string().email()
});
var bookedBedDelayRuleValidationSchema = Yup62.object({
  type: Yup62.string().oneOf(delayRuleTypes).required(),
  value: Yup62.number().required()
});
var viaTrajectoireOptionsValidationSchema = Yup62.object({
  isActivated: Yup62.boolean(),
  codeSih: Yup62.string()
});
var UpdateHealthCenterValidation = Yup62.object({
  id: Yup62.string().required(),
  name: Yup62.string(),
  autodispatchActivated: Yup62.boolean(),
  autoComputeOccupanciesActivated: Yup62.boolean(),
  fareGroupActivated: Yup62.boolean(),
  fareGroupTimeInterval: Yup62.number(),
  portersLimitByFarePositionLyingDownBed: Yup62.number(),
  portersLimitByFarePositionLyingDown: Yup62.number(),
  portersLimitByFarePositionSittingUp: Yup62.number(),
  portersLimitByFarePositionWalking: Yup62.number(),
  autodispatchTimeInMinutesAnticipation: Yup62.number(),
  groups: Yup62.array().of(HealthCenterGroupValidationSchema.required()),
  finess: Yup62.string(),
  rorOptions: rorOptionsValidationSchema.default(void 0),
  computeAnomaliesActivated: Yup62.boolean(),
  bookedBedDelayRule: bookedBedDelayRuleValidationSchema.default(void 0),
  computeEmergencyOccupancies: Yup62.string().oneOf(computeEmergencyOccupanciesOptions),
  hasPediatricService: Yup62.boolean(),
  autoComputeDischarge: Yup62.boolean(),
  location: Yup62.object({
    latitude: Yup62.number().required(),
    longitude: Yup62.number().required()
  }).default(void 0),
  viaTrajectoireOptions: viaTrajectoireOptionsValidationSchema.default(void 0),
  patientTransportEnabled: Yup62.boolean(),
  chatSupportEnabled: Yup62.boolean(),
  thesaurusEnabled: Yup62.boolean(),
  thesaurusReasonEnabled: Yup62.boolean(),
  thesaurusUnitsSuggestionsEnabled: Yup62.boolean()
});
var updateHealthCenter = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "update-healthcenter",
    params,
    options
  );
};
var updateHealthCenter_default = updateHealthCenter;

// src/cloud/structure/updateUnit.ts
import * as Yup63 from "yup";
var UnitManualOccupancyValidation2 = Yup63.object({
  open: Yup63.number().min(0, i18n.manualOccupancyCanNotBeNegative).required()
});
var UpdateUnitValidation = Yup63.object({
  id: Yup63.string().required(),
  name: Yup63.string(),
  areaIds: Yup63.array(Yup63.string().required()),
  requestFareConfirmation: Yup63.boolean(),
  externalId: Yup63.string(),
  type: Yup63.string().oneOf(unitTypes),
  department: Yup63.string(),
  defaultFarePositionFromThis: Yup63.string().oneOf(farePositions),
  specialties: Yup63.array(Yup63.string().oneOf(specialties).required()),
  contacts: Yup63.array().of(ContactValidation.required()),
  autoComputeOccupanciesActivated: Yup63.boolean(),
  responsibleUnits: Yup63.array(Yup63.string().required()),
  autoComputeDischarge: Yup63.boolean(),
  isEmergency: Yup63.boolean(),
  manualOccupancyActivated: Yup63.boolean(),
  manualOccupancy: UnitManualOccupancyValidation2.default(void 0)
});
var updateUnit = (params, options) => {
  return parse_instance_browser_default.Cloud.run("update-unit", params, options);
};
var updateUnit_default = updateUnit;

// src/cloud/takeBreak.ts
import * as Yup64 from "yup";

// src/models/Porter.ts
var porterBreak = ["COFFEE_BREAK", "LUNCH_BREAK"];
var Porter = class extends ParseClass {
  constructor(attributes) {
    super("Porter", attributes);
  }
  get firstName() {
    return this.Get("firstName");
  }
  set firstName(val) {
    this.Set("firstName", val);
  }
  get units() {
    return this.Get("units");
  }
  set units(val) {
    this.Set("units", val);
  }
  get lastName() {
    return this.Get("lastName");
  }
  set lastName(val) {
    this.Set("lastName", val);
  }
  get user() {
    return this.Get("user");
  }
  set user(val) {
    this.Set("user", val);
  }
  get lastActivityAt() {
    return this.Get("lastActivityAt");
  }
  set lastActivityAt(val) {
    this.Set("lastActivityAt", val);
  }
  get status() {
    return this.Get("status");
  }
  set status(val) {
    this.Set("status", val);
  }
  get breakType() {
    return this.Get("breakType");
  }
  set breakType(val) {
    this.Set("breakType", val);
  }
  get breakStartedAt() {
    return this.Get("breakStartedAt");
  }
  set breakStartedAt(val) {
    this.Set("breakStartedAt", val);
  }
  get lastArea() {
    return this.Get("lastArea");
  }
  set lastArea(val) {
    this.Set("lastArea", val);
  }
  get lastUnit() {
    return this.Get("lastUnit");
  }
  set lastUnit(val) {
    this.Set("lastUnit", val);
  }
  get lastAreaAt() {
    return this.Get("lastAreaAt");
  }
  set lastAreaAt(val) {
    this.Set("lastAreaAt", val);
  }
  get nextArea() {
    return this.Get("nextArea");
  }
  set nextArea(val) {
    this.Set("nextArea", val);
  }
  get nextUnit() {
    return this.Get("nextUnit");
  }
  set nextUnit(val) {
    this.Set("nextUnit", val);
  }
  get fareAssignedCount() {
    return this.Get("fareAssignedCount");
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  resetFareAssignedCount() {
    this.Set("fareAssignedCount", 0);
  }
  incrementFareAssignedCount() {
    this.increment("fareAssignedCount");
  }
  decrementFareAssignedCount() {
    if (Number(this.Get("fareAssignedCount")) > 0) {
      this.increment("fareAssignedCount", -1);
    }
  }
  get fareDoneCount() {
    return this.Get("fareDoneCount");
  }
  resetFareDoneCount() {
    this.Set("fareDoneCount", 0);
  }
  incrementFareDoneCount() {
    this.increment("fareDoneCount");
  }
  decrementFareDoneCount() {
    if (Number(this.Get("fareDoneCount")) > 0) {
      this.increment("fareDoneCount", -1);
    }
  }
  get hasInternet() {
    return this.Get("hasInternet");
  }
  set hasInternet(val) {
    this.Set("hasInternet", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("Porter", Porter);

// src/cloud/takeBreak.ts
var TakeBreakValidation = Yup64.object({
  breakType: Yup64.string().oneOf(porterBreak, i18n.breakTypeRequired).required(i18n.breakTypeRequired)
});
var takeBreak = (params, options) => {
  return parse_instance_browser_default.Cloud.run("take-break", params, options);
};
var takeBreak_default = takeBreak;

// src/cloud/toggleAutodispatch.ts
var toggleAutodispatch = (options) => {
  return parse_instance_browser_default.Cloud.run("toggle-autodispatch", null, options);
};
var toggleAutodispatch_default = toggleAutodispatch;

// src/cloud/updateFare.ts
import * as Yup65 from "yup";
var UpdateFareValidation = Yup65.object({
  patientId: Yup65.string(),
  specificities: Yup65.array(Yup65.string().oneOf(fareSpecificities).required()).notRequired(),
  position: Yup65.string().oneOf(farePositions),
  comment: Yup65.string().notRequired(),
  wantedDate: Yup65.date().notRequired(),
  isEmergency: Yup65.boolean(),
  roundTrip: Yup65.boolean(),
  fromAreaId: Yup65.string().notRequired(),
  toAreaId: Yup65.string().notRequired(),
  fromUnitId: Yup65.string(),
  toUnitId: Yup65.string(),
  fareId: Yup65.string().required(i18n.fareIdRequired),
  procedureExternalId: Yup65.string(),
  fromStep: Yup65.object({
    id: Yup65.string().required(),
    type: Yup65.string().oneOf(["accommodation", "appointment"]).required()
  }).default(void 0),
  toStep: Yup65.object({
    id: Yup65.string().required(),
    type: Yup65.string().oneOf(["accommodation", "appointment"]).required()
  }).default(void 0)
});
var updateFare = (params, options) => {
  return parse_instance_browser_default.Cloud.run("update-fare", params, options);
};
var updateFare_default = updateFare;

// src/cloud/updateInstallation.ts
import * as Yup66 from "yup";
var UpdateInstallationValidation = Yup66.object({
  installationId: Yup66.string().required(),
  deviceType: Yup66.string().required(),
  deviceToken: Yup66.string().required()
});
var updateInstallation = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "update-installation",
    params,
    options
  );
};
var updateInstallation_default = updateInstallation;

// src/cloud/updateJourney/updateJourney.ts
import * as Yup67 from "yup";
var UpdateJourneyStepValidation = Yup67.object({
  fareId: Yup67.string(),
  toUnitId: Yup67.string().required(i18n.unitRequired),
  toAreaId: Yup67.string(),
  wantedDate: Yup67.date().required(i18n.dateRequired)
});
var UpdateJourneyValidation = Yup67.object({
  journeyId: Yup67.string().required(),
  patientId: Yup67.string().required(i18n.patientRequired),
  roundTrip: Yup67.boolean().required(),
  position: Yup67.string().oneOf(farePositions).required(i18n.positionRequired).required(),
  comment: Yup67.string(),
  isEmergency: Yup67.boolean(),
  specificities: Yup67.array().of(Yup67.string().oneOf(fareSpecificities).required()),
  fromUnitId: Yup67.string().required(i18n.unitRequired),
  fromAreaId: Yup67.string(),
  steps: Yup67.array().of(UpdateJourneyStepValidation.required()).required()
});
var updateJourney = (params, options) => {
  return parse_instance_browser_default.Cloud.run("update-journey", params, options);
};

// src/cloud/updateOccupancy.ts
import * as Yup68 from "yup";
var OccupancyGenderDistributionSchema = Yup68.object({
  indifferent: Yup68.number().integer().required(),
  male: Yup68.number().integer().required(),
  female: Yup68.number().integer().required()
});
var UpdateOccupancyValidation = Yup68.object({
  covid: Yup68.number().integer().required(),
  isolated: Yup68.number().integer().required(),
  isolatedAir: Yup68.number().integer().required(),
  isolatedDroplet: Yup68.number().integer().required(),
  isolatedContact: Yup68.number().integer().required(),
  isolatedProtector: Yup68.number().integer().required(),
  waitingForDownstreamBed: Yup68.number().integer().required(),
  accomodated: Yup68.number().integer().required(),
  unitId: Yup68.string().required(),
  close: Yup68.number().integer().required(),
  open: Yup68.number().integer().required(),
  admission: Yup68.number().integer().required(),
  discharge: Yup68.number().integer().required(),
  unavailableExcluded: Yup68.number().integer(),
  dDayAvailabilities: OccupancyGenderDistributionSchema.required(),
  h24Availabilities: OccupancyGenderDistributionSchema.required(),
  h48Availabilities: OccupancyGenderDistributionSchema.required(),
  comment: Yup68.string()
});
var updateOccupancy = (params, options) => {
  return parse_instance_browser_default.Cloud.run("update-occupancy", params, options);
};
var updateOccupancy_default = updateOccupancy;

// src/cloud/updatePractitioner/updatePractitioner.ts
import * as Yup69 from "yup";
var UpdatePractitionerValidation = Yup69.object({
  id: Yup69.string().required(),
  firstName: Yup69.string(),
  lastName: Yup69.string(),
  color: Yup69.string()
});
var updatePractitioner = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "update-practitioner",
    params,
    options
  );
};

// src/cloud/updateVisit.ts
import * as Yup70 from "yup";
var patientOutcomeValidation = Yup70.object({
  type: Yup70.string().notRequired().oneOf([...patientOutcomeTypes, null]),
  comment: Yup70.string().notRequired(),
  viaTrajectoireReportNumber: Yup70.number()
});
var updateVisitValidation = Yup70.object({
  visitId: Yup70.string().required(),
  patientOutcome: patientOutcomeValidation.default(void 0)
});
var updateVisit = (params, options) => parse_instance_browser_default.Cloud.run("update-visit", params, options);
var updateVisit_default = updateVisit;

// src/cloud/users/createUser.ts
import * as Yup72 from "yup";

// src/models/NavigationACL.ts
var KURT_ROUTES = [
  "kurt",
  "kurt.territory",
  "kurt.healthCenter",
  "kurt.unit",
  "kurt.movements",
  "kurt.emergency"
];
var SABRI_ROUTES = ["sabri", "sabri.settings", "sabri.fares", "sabri.team"];
var ADMIN_ROUTES = [
  "admin",
  "admin.healthCenter",
  "admin.units",
  "admin.areas",
  "admin.users",
  "admin.patients",
  "admin.appointments",
  "admin.externalTransports",
  "admin.healthcareEnvironmentalCleaning",
  "admin.anomalies",
  "admin.emergencies",
  "admin.thesaurus",
  "admin.overview",
  "admin.beds",
  "admin.practitioners"
];
var NAVIGATION_ROUTES = [...KURT_ROUTES, ...SABRI_ROUTES, ...ADMIN_ROUTES];

// src/models/interop-message/InteropMessage.ts
var InteropMessage = class extends ParseClass {
  constructor(params) {
    super("InteropMessage", params);
  }
  set hash(value) {
    this.Set("hash", value);
  }
  get hash() {
    return this.Get("hash");
  }
  set status(value) {
    this.Set("status", value);
  }
  get status() {
    return this.Get("status");
  }
  set username(value) {
    this.Set("username", value);
  }
  get username() {
    return this.Get("username");
  }
  set healthCenter(value) {
    this.Set("healthCenter", value);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set source(value) {
    this.Set("source", value);
  }
  get source() {
    return this.Get("source");
  }
  set sourceFilePath(value) {
    this.Set("sourceFilePath", value);
  }
  get sourceFilePath() {
    return this.Get("sourceFilePath");
  }
  set messageId(value) {
    this.Set("messageId", value);
  }
  get messageId() {
    return this.Get("messageId");
  }
  set messageDate(value) {
    this.Set("messageDate", value);
  }
  get messageDate() {
    return this.Get("messageDate");
  }
  set movementIds(value) {
    this.Set("movementIds", value);
  }
  get movementIds() {
    return this.Get("movementIds");
  }
  set movementType(value) {
    this.Set("movementType", value);
  }
  get movementType() {
    return this.Get("movementType");
  }
  set movementDate(value) {
    this.Set("movementDate", value);
  }
  get movementDate() {
    return this.Get("movementDate");
  }
  set movementAction(value) {
    this.Set("movementAction", value);
  }
  get movementAction() {
    return this.Get("movementAction");
  }
  set pan(value) {
    this.Set("pan", value);
  }
  get pan() {
    return this.Get("pan");
  }
  set data(value) {
    this.Set("data", value);
  }
  get data() {
    return this.Get("data");
  }
};
parse_instance_browser_default.Object.registerSubclass("InteropMessage", InteropMessage);

// src/models/User.ts
var webUserRoles = [...["REGULATOR", "MANAGER", "ADMIN_REGULATOR", "ADMIN", "BED_MANAGER"]];
var userRoles = [...[...webUserRoles, "PORTER"]];
var User = class extends ParseUser {
  constructor(attributes) {
    super(attributes);
  }
  get username() {
    return this.Get("username");
  }
  set username(val) {
    this.Set("username", val);
  }
  get password() {
    return this.Get("password");
  }
  set password(val) {
    this.Set("password", val);
  }
  get email() {
    return this.Get("email");
  }
  set email(val) {
    this.Set("email", val);
  }
  get role() {
    return this.Get("role");
  }
  set role(val) {
    this.Set("role", val);
  }
  get porter() {
    return this.Get("porter");
  }
  set porter(val) {
    this.Set("porter", val);
  }
  get healthCenters() {
    return this.Get("healthCenters");
  }
  set healthCenters(val) {
    this.Set("healthCenters", val);
  }
  get unit() {
    return this.Get("unit");
  }
  set unit(val) {
    this.Set("unit", val);
  }
  get units() {
    return this.Get("units");
  }
  set units(val) {
    this.Set("units", val);
  }
  get notificationConfigurations() {
    return this.Get("notificationConfigurations");
  }
  set notificationConfigurations(val) {
    this.Set("notificationConfigurations", val);
  }
  get navigationACL() {
    return this.Get("navigationACL");
  }
  set navigationACL(val) {
    this.Set("navigationACL", val);
  }
  get isReadOnly() {
    return this.Get("isReadOnly");
  }
  set isReadOnly(val) {
    this.Set("isReadOnly", val);
  }
  get whitelistedIPs() {
    return this.Get("whitelistedIPs");
  }
  set whitelistedIPs(val) {
    this.Set("whitelistedIPs", val);
  }
  get disabled() {
    return this.Get("disabled");
  }
  set disabled(val) {
    this.Set("disabled", val);
  }
  get disabledAt() {
    return this.Get("disabledAt");
  }
  set disabledAt(val) {
    this.Set("disabledAt", val);
  }
  get disabledReason() {
    return this.Get("disabledReason");
  }
  set disabledReason(val) {
    this.Set("disabledReason", val);
  }
  get lastConnectionAt() {
    return this.Get("lastConnectionAt");
  }
  set lastConnectionAt(val) {
    this.Set("lastConnectionAt", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("_User", User);

// src/models/notifications/fare/fareNotification.ts
var FARE_ASSIGNED_DEFAULT_CONFIGURATION = {
  isAcknowledgeNeeded: true,
  notificationsProviders: ["IN_APP", "PUSH_MOBILE"],
  triggerEvent: "FARE_ASSIGNED",
  retryPolicy: {
    retryDelayInSeconds: 10,
    maxRetryCount: 5
  }
};
var FARE_UNASSIGNED_DEFAULT_CONFIGURATION = {
  isAcknowledgeNeeded: true,
  notificationsProviders: ["IN_APP", "PUSH_MOBILE"],
  triggerEvent: "FARE_UNASSIGNED",
  retryPolicy: {
    retryDelayInSeconds: 10,
    maxRetryCount: 5
  }
};

// src/models/notifications/fare/fareReadyToBeAssignedNotification.ts
var FARE_READY_TO_BE_ASSIGNED_DEFAULT_CONFIGURATION = {
  isAcknowledgeNeeded: false,
  notificationsProviders: ["WEB"],
  triggerEvent: "FARE_READY_TO_BE_ASSIGNED",
  retryPolicy: {
    retryDelayInSeconds: 10,
    maxRetryCount: 5
  }
};

// src/models/notifications/fare/fareUpdatedNotification.ts
var FARE_UPDATED_DEFAULT_CONFIGURATION = {
  isAcknowledgeNeeded: true,
  notificationsProviders: ["IN_APP", "PUSH_MOBILE"],
  triggerEvent: "FARE_UPDATED",
  retryPolicy: {
    retryDelayInSeconds: 10,
    maxRetryCount: 5
  }
};
var getFaresDifferences = (oldFare, newFare) => {
  const differences = [];
  if (oldFare.patient.id !== newFare.patient.id) {
    differences.push({
      type: "patient",
      newValue: {
        firstName: newFare.patient.firstName,
        age: newFare.patient.age,
        birthdate: newFare.patient.birthdate,
        gender: newFare.patient.gender,
        lastName: newFare.patient.lastName
      },
      oldValue: {
        firstName: oldFare.patient.firstName,
        age: oldFare.patient.age,
        birthdate: oldFare.patient.birthdate,
        gender: oldFare.patient.gender,
        lastName: oldFare.patient.lastName
      }
    });
  }
  if (oldFare.fromUnit.id !== newFare.fromUnit.id || oldFare.fromArea?.id !== newFare.fromArea?.id) {
    differences.push({
      type: "fromLocation",
      newValue: { unit: newFare.fromUnit.id, areasBreadcrumb: newFare.fromArea?.id },
      oldValue: { unit: oldFare.fromUnit.id, areasBreadcrumb: oldFare.fromArea?.id }
    });
  }
  if (oldFare.toUnit.id !== newFare.toUnit.id || oldFare.toArea?.id !== newFare.toArea?.id) {
    differences.push({
      type: "toLocation",
      newValue: { unit: newFare.toUnit.id, areasBreadcrumb: newFare.toArea?.id },
      oldValue: { unit: oldFare.toUnit.id, areasBreadcrumb: oldFare.toArea?.id }
    });
  }
  if (oldFare.position !== newFare.position) {
    differences.push({
      type: "position",
      newValue: newFare.position,
      oldValue: oldFare.position
    });
  }
  if (JSON.stringify(oldFare.specificities) !== JSON.stringify(newFare.specificities)) {
    differences.push({
      type: "specificities",
      newValue: newFare.specificities ? newFare.specificities : [],
      oldValue: oldFare.specificities ? oldFare.specificities : []
    });
  }
  if (oldFare.comment !== newFare.comment) {
    differences.push({
      type: "comment",
      newValue: newFare.comment,
      oldValue: oldFare.comment
    });
  }
  return differences;
};

// src/models/notifications/fare/newFareIncidentNotification.ts
var NEW_FARE_INCIDENT_DEFAULT_CONFIGURATION = {
  isAcknowledgeNeeded: false,
  notificationsProviders: ["WEB"],
  triggerEvent: "FARE_UPDATED"
};

// src/models/notifications/notification.ts
import * as Yup71 from "yup";
var notificationTriggerEvent = [
  "FARE_ASSIGNED",
  "FARE_UNASSIGNED",
  "FARE_UPDATED",
  "PORTER_SUPPORT_ASSIGNED",
  "PORTER_SUPPORT_UNASSIGNED",
  "FARE_READY_TO_BE_ASSIGNED",
  "NEW_FARE_INCIDENT",
  "PORTER_START_OF_SERVICE",
  "PORTER_END_OF_SERVICE",
  "NEW_PERFORMER_REQUEST",
  "PERFORMER_REQUEST_ACCEPTED",
  "PERFORMER_REQUEST_REJECTED"
];
var notificationProvider = ["WEB", "IN_APP", "PUSH_MOBILE"];
var retryPolicyValidation = Yup71.object({
  retryDelayInSeconds: Yup71.number().required(),
  maxRetryCount: Yup71.number().required()
});
var notificationConfigurationValidation = Yup71.object({
  triggerEvent: Yup71.string().oneOf(notificationTriggerEvent).required(),
  isAcknowledgeNeeded: Yup71.boolean(),
  retryPolicy: retryPolicyValidation.default(void 0),
  notificationsProviders: Yup71.array().of(Yup71.string().oneOf(notificationProvider).required()).required()
});
var Notification = class extends ParseClass {
  constructor(attributes) {
    super("Notification", attributes);
  }
  get acknowledgedAt() {
    return this.Get("acknowledgedAt");
  }
  set acknowledgedAt(val) {
    this.Set("acknowledgedAt", val);
  }
  get triggerEvent() {
    return this.Get("triggerEvent");
  }
  set triggerEvent(val) {
    this.Set("triggerEvent", val);
  }
  get sendTo() {
    return this.Get("sendTo");
  }
  set sendTo(val) {
    this.Set("sendTo", val);
  }
  get sentNotifications() {
    return this.Get("sentNotifications");
  }
  set sentNotifications(val) {
    this.Set("sentNotifications", val);
  }
  get status() {
    return this.Get("status");
  }
  set status(val) {
    this.Set("status", val);
  }
  get data() {
    return this.Get("data");
  }
  set data(val) {
    this.Set("data", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("Notification", Notification);

// src/models/notifications/porter/porterServiceNotification.ts
var PORTER_START_OF_SERVICE_DEFAULT_CONFIGURATION = {
  isAcknowledgeNeeded: false,
  notificationsProviders: ["WEB"],
  triggerEvent: "PORTER_START_OF_SERVICE"
};
var PORTER_END_OF_SERVICE_DEFAULT_CONFIGURATION = {
  isAcknowledgeNeeded: false,
  notificationsProviders: ["WEB"],
  triggerEvent: "PORTER_END_OF_SERVICE"
};

// src/models/notifications/porter/porterSupportNotification.ts
var PORTER_SUPPORT_ASSIGNED_DEFAULT_CONFIGURATION = {
  isAcknowledgeNeeded: true,
  notificationsProviders: ["IN_APP", "PUSH_MOBILE"],
  triggerEvent: "PORTER_SUPPORT_ASSIGNED",
  retryPolicy: {
    retryDelayInSeconds: 10,
    maxRetryCount: 5
  }
};
var PORTER_SUPPORT_UNASSIGNED_DEFAULT_CONFIGURATION = {
  isAcknowledgeNeeded: true,
  notificationsProviders: ["IN_APP", "PUSH_MOBILE"],
  triggerEvent: "PORTER_SUPPORT_UNASSIGNED",
  retryPolicy: {
    retryDelayInSeconds: 10,
    maxRetryCount: 5
  }
};

// src/models/notifications/step/newPerformerRequestNotification.ts
var NEW_PERFORMER_REQUEST_DEFAULT_CONFIGURATION = {
  isAcknowledgeNeeded: false,
  notificationsProviders: ["WEB", "PUSH_MOBILE"],
  triggerEvent: "NEW_PERFORMER_REQUEST"
};

// src/models/notifications/step/performerRequestAcceptedNotification.ts
var PERFORMER_REQUEST_ACCEPTED_DEFAULT_CONFIGURATION = {
  isAcknowledgeNeeded: false,
  notificationsProviders: ["WEB"],
  triggerEvent: "PERFORMER_REQUEST_ACCEPTED"
};

// src/models/notifications/step/performerRequestRejectedNotification.ts
var PERFORMER_REQUEST_REJECTED_DEFAULT_CONFIGURATION = {
  isAcknowledgeNeeded: false,
  notificationsProviders: ["WEB"],
  triggerEvent: "PERFORMER_REQUEST_REJECTED"
};

// src/models/notifications/notificationConfigurations.ts
var DEFAULT_NOTIFICATION_CONFIGURATION = {
  FARE_ASSIGNED: FARE_ASSIGNED_DEFAULT_CONFIGURATION,
  FARE_UPDATED: FARE_UPDATED_DEFAULT_CONFIGURATION,
  FARE_UNASSIGNED: FARE_UNASSIGNED_DEFAULT_CONFIGURATION,
  PORTER_SUPPORT_ASSIGNED: PORTER_SUPPORT_ASSIGNED_DEFAULT_CONFIGURATION,
  PORTER_SUPPORT_UNASSIGNED: PORTER_SUPPORT_UNASSIGNED_DEFAULT_CONFIGURATION,
  FARE_READY_TO_BE_ASSIGNED: FARE_READY_TO_BE_ASSIGNED_DEFAULT_CONFIGURATION,
  NEW_FARE_INCIDENT: NEW_FARE_INCIDENT_DEFAULT_CONFIGURATION,
  PORTER_START_OF_SERVICE: PORTER_START_OF_SERVICE_DEFAULT_CONFIGURATION,
  PORTER_END_OF_SERVICE: PORTER_END_OF_SERVICE_DEFAULT_CONFIGURATION,
  NEW_PERFORMER_REQUEST: NEW_PERFORMER_REQUEST_DEFAULT_CONFIGURATION,
  PERFORMER_REQUEST_ACCEPTED: PERFORMER_REQUEST_ACCEPTED_DEFAULT_CONFIGURATION,
  PERFORMER_REQUEST_REJECTED: PERFORMER_REQUEST_REJECTED_DEFAULT_CONFIGURATION
};

// src/cloud/users/createUser.ts
var CreateUserValidation = Yup72.object({
  username: Yup72.string(),
  role: Yup72.string().oneOf(userRoles).required(),
  firstName: Yup72.string().when("role", {
    is: "PORTER",
    then: () => Yup72.string().required()
  }),
  lastName: Yup72.string().when("role", {
    is: "PORTER",
    then: () => Yup72.string().required()
  }),
  unitId: Yup72.string().when("role", {
    is: "MANAGER",
    then: () => Yup72.string().required()
  }),
  notificationConfigurations: Yup72.array().of(notificationConfigurationValidation.required()),
  navigationACL: Yup72.array().of(Yup72.string().oneOf(NAVIGATION_ROUTES).required()),
  units: Yup72.array().of(Yup72.string().required()),
  isReadOnly: Yup72.boolean(),
  password: Yup72.string(),
  isUnsafePassword: Yup72.boolean(),
  whitelistedIPs: Yup72.array().of(Yup72.string().required()),
  healthCenterId: Yup72.string().required()
}).required();
var createUser = (params, options) => {
  return parse_instance_browser_default.Cloud.run("create-user", params, options);
};
var createUser_default = createUser;

// src/cloud/users/linkExternalUser.ts
import * as Yup73 from "yup";
var LinkExternalUserValidation = Yup73.object({
  id: Yup73.string().required(),
  username: Yup73.string().required(),
  accessToken: Yup73.string().required()
}).required();
var linkExternalUser = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "link-external-user",
    params,
    options
  );
};
var linkExternalUser_default = linkExternalUser;

// src/cloud/users/updateUser.ts
import * as Yup74 from "yup";
var UpdateUserValidation = Yup74.object({
  id: Yup74.string().required(),
  firstName: Yup74.string(),
  lastName: Yup74.string(),
  unitId: Yup74.string(),
  healthCenterId: Yup74.string(),
  notificationConfigurations: Yup74.array().of(notificationConfigurationValidation.required()),
  navigationACL: Yup74.array().of(Yup74.string().oneOf(NAVIGATION_ROUTES).required()),
  units: Yup74.array().of(Yup74.string().required()),
  isReadOnly: Yup74.boolean(),
  password: Yup74.string(),
  isUnsafePassword: Yup74.boolean(),
  whitelistedIPs: Yup74.array().of(Yup74.string().required()),
  disabled: Yup74.boolean(),
  disabledReason: Yup74.string()
}).required();
var updateUser = (params, options) => {
  return parse_instance_browser_default.Cloud.run("update-user", params, options);
};
var updateUser_default = updateUser;

// src/cloud/userTick.ts
var userTick = (options) => {
  return parse_instance_browser_default.Cloud.run("user-tick", null, options);
};
var userTick_default = userTick;

// src/interop/index.ts
var interop_exports = {};
__export(interop_exports, {
  message: () => message_exports
});

// src/interop/message/index.ts
var message_exports = {};
__export(message_exports, {
  APPOINTMENT_MESSAGE_TYPES: () => APPOINTMENT_MESSAGE_TYPES,
  TYPES: () => TYPES,
  VISIT_TYPES: () => VISIT_TYPES,
  data: () => data_exports,
  isAppointmentMessage: () => isAppointmentMessage,
  isVisitMessage: () => isVisitMessage,
  movementActions: () => movementActions
});

// src/interop/message/data.ts
var data_exports = {};

// src/interop/message/type.ts
var APPOINTMENT_MESSAGE_TYPES = ["CREATE_APPOINTMENT", "UPDATE_APPOINTMENT"];
var VISIT_TYPES = [
  "ADMIT_PATIENT",
  "CANCEL_ADMIT_PATIENT",
  "DISCHARGE_PATIENT",
  "CANCEL_DISCHARGE_PATIENT",
  "TRANSFER_PATIENT",
  "CANCEL_TRANSFER_PATIENT",
  "PRE_ADMIT_PATIENT",
  "CANCEL_PRE_ADMIT_PATIENT",
  "CHANGE_OUTPATIENT_TO_INPATIENT",
  "PENDING_DISCHARGE_PATIENT",
  "UPDATE_RESPONSIBLE_UNIT",
  "CHANGE_INPATIENT_TO_OUTPATIENT",
  "RETURN_FROM_LEAVE_OF_ABSENCE"
];
var TYPES = [
  ...VISIT_TYPES,
  ...APPOINTMENT_MESSAGE_TYPES,
  "CREATE_PATIENT",
  "UPDATE_PATIENT",
  "MERGE_PATIENT"
];

// src/interop/message/message.ts
var movementActions = ["INSERT", "UPDATE", "CANCEL"];
var isAppointmentMessage = (message) => APPOINTMENT_MESSAGE_TYPES.includes(message.type);
var isVisitMessage = (message) => VISIT_TYPES.includes(message.type);

// src/models/Anomaly.ts
var anomalyType = [
  "OVERLAPPING_STEPS",
  "OUTDATED_PREVISIONAL_END",
  "OUTDATED_VALIDATED_END",
  "OUTDATED_START"
];
var anomalyStatus = ["OPENED", "RESOLVED"];
var Anomaly = class extends ParseClass {
  constructor(attributes) {
    super("Anomaly", attributes);
  }
  get area() {
    return this.Get("area");
  }
  set area(val) {
    this.Set("area", val);
  }
  get accommodation() {
    return this.Get("accommodation");
  }
  set accommodation(val) {
    this.Set("accommodation", val);
  }
  get startAt() {
    return this.Get("startAt");
  }
  set startAt(val) {
    this.Set("startAt", val);
  }
  get endAt() {
    return this.Get("endAt");
  }
  set endAt(val) {
    this.Set("endAt", val);
  }
  get type() {
    return this.Get("type");
  }
  set type(val) {
    this.Set("type", val);
  }
  get linkedWith() {
    return this.Get("linkedWith");
  }
  set linkedWith(val) {
    this.Set("linkedWith", val);
  }
  get status() {
    return this.Get("status");
  }
  set status(val) {
    this.Set("status", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("Anomaly", Anomaly);

// src/models/AreaTree.ts
import hash from "object-hash";
var findAreaKeyWord = (a, wordList) => {
  const key = Object.keys(wordList).reduce(
    (savedWord, word) => a.name.toLowerCase().includes(word) ? wordList[word] < wordList[savedWord] ? word : savedWord : savedWord
  );
  return wordList[key];
};
var AreaTree = class {
  constructor(areas, units) {
    this.areas = areas;
    this.units = units || [];
    this.areaMap = {};
    this.root = void 0;
    this.selectedAreasHash = void 0;
    this.selectedAreas = [];
    this.recentChildren = [];
    this.areaIdUnitRecord = {};
    this.areaByExternalId = {};
    this.init(areas, units || []);
  }
  /**
   * Initialise l'arbre
   * @param areas
   */
  init(areas, units) {
    for (const area of areas) {
      this.areaMap[area.id] = area;
      if (!area.parent) {
        this.root = area;
      }
      for (const externalId of area.externalIds || []) {
        this.areaByExternalId[externalId] = area;
      }
    }
    for (const area of areas) {
      const currentArea = this.areaMap[area.id];
      if (area.parent && this.areaMap[area.parent.id]) {
        const parent = this.areaMap[area.parent.id];
        area.parent = parent;
        if (parent.children) {
          parent.children.push(currentArea);
        } else {
          parent.children = [currentArea];
        }
      }
    }
    for (const unit of units || []) {
      const unitAreas = unit.areas || [];
      const allChildren = [...this.getAllChildren(unitAreas.map((area) => area.id)), ...unitAreas];
      for (const area of allChildren) {
        this.areaIdUnitRecord[area.id] = unit;
      }
    }
  }
  /**
   * Retourne une unité à partir d'un area id
   * @param areaId
   * @returns Unit
   */
  getUnitFromAreaId(areaId) {
    return this.areaIdUnitRecord[areaId];
  }
  /**
   * Retourne une area à partir d'un externalId
   * @param externalId
   * @returns Area
   */
  getAreaByExternalId(externalId) {
    return this.areaByExternalId[externalId];
  }
  /**
   * Retourne un area à partir d'un id
   * @param id
   */
  getAreaById(id) {
    return this.areaMap[id];
  }
  /**
   * Retourne tous les enfants en flatMap d'une liste d'Area (non comprise)
   * @param areas
   */
  getAllChildren(areas) {
    if (!areas) {
      if (this.root) {
        const selectedAreas = [this.root];
        const selectedAreasHash = hash(selectedAreas.map((area) => area.id));
        if (selectedAreasHash === this.selectedAreasHash) {
          return this.recentChildren;
        } else {
          this.selectedAreasHash = selectedAreasHash;
          this.selectedAreas = selectedAreas;
        }
      } else {
        return [];
      }
    } else {
      const selectedAreas = [];
      for (const area of areas) {
        if (typeof area === "string") {
          const areaFromId = this.getAreaById(area);
          if (areaFromId) {
            selectedAreas.push(areaFromId);
          }
        } else {
          selectedAreas.push(area);
        }
      }
      const selectedAreasHash = hash(selectedAreas.map((area) => area.id));
      if (selectedAreasHash === this.selectedAreasHash) {
        return this.recentChildren;
      } else {
        this.selectedAreasHash = selectedAreasHash;
        this.selectedAreas = selectedAreas;
      }
    }
    const queue = [];
    for (const area of this.selectedAreas) {
      if (area.children) {
        queue.push(...area.children);
      }
    }
    const result = [];
    while (queue.length > 0) {
      const currentArea = queue.shift();
      if (!currentArea) {
        continue;
      }
      result.push(currentArea);
      if (currentArea.children) {
        queue.push(...currentArea.children);
      }
    }
    this.recentChildren = result;
    return this.recentChildren;
  }
  /**
   * Cette fonction retourne un tableau de chemin d'Area à partir d'un Area enfant.
   * Exemple si l'Area passé est un pousse-seringue localisé dans une chambre alors ça retournera
   * ["Chambre 2", "Lit 1", "Pousse-seringue"]
   * @param area Area[]
   * @returns Area[]
   */
  getBreadcrumb({ area, areaId }) {
    const currentArea = area || this.getAreaById(areaId || "");
    if (!currentArea) {
      return [];
    }
    if (currentArea.isSearchable) {
      return [currentArea];
    }
    const breadcrumb = [currentArea];
    while (!breadcrumb[0].isSearchable && breadcrumb[0].parent) {
      breadcrumb.unshift(breadcrumb[0].parent);
    }
    return breadcrumb;
  }
  /**
   * Cette fonction retourne toutes les paths possibles entre deux Area d'entrée
   * @param fromArea
   * @param toArea
   */
  getAllPaths(fromArea, toArea) {
    const localFromArea = this.getAreaById(fromArea.id);
    const localToArea = this.getAreaById(toArea.id);
    if (!localFromArea || !localToArea) {
      return [];
    }
    let fromBranchAreas = [];
    let toBranchAreas = [];
    let queue = [];
    queue.push({
      area: !localFromArea.children && localFromArea.parent ? localFromArea.parent : localFromArea,
      moves: 0,
      branch: "FROM"
    });
    queue.push({
      area: !localToArea.children && localToArea.parent ? localToArea.parent : localToArea,
      moves: 0,
      branch: "TO"
    });
    while (queue.length) {
      const current = queue.shift();
      if (!current) {
        continue;
      }
      const { area, moves, branch, direction } = current;
      let currentBranch = branch === "FROM" ? fromBranchAreas : toBranchAreas;
      let oppositeBranch = branch === "FROM" ? toBranchAreas : fromBranchAreas;
      if (!area) {
        continue;
      }
      if (!area.parent) {
        continue;
      }
      if (!area.children) {
        continue;
      }
      const commonArea = oppositeBranch.find((seenArea) => seenArea.area.id === area.id);
      if (commonArea) {
        if (branch === "FROM") {
          toBranchAreas = toBranchAreas.filter((seenArea) => seenArea.moves > commonArea.moves);
        } else {
          fromBranchAreas = fromBranchAreas.filter((seenArea) => seenArea.moves > commonArea.moves);
        }
        queue = queue.filter((queueObj) => queueObj.direction !== "UP");
        continue;
      }
      currentBranch.push({ area, moves });
      if (direction === "UP") {
        queue.push({ area: area.parent, moves: moves - 1, branch, direction: "UP" });
      } else if (direction === "DOWN") {
        queue.push(...area.children.map((area2) => ({ area: area2, moves: moves + 1, branch, direction: "DOWN" })));
      } else {
        queue.push({ area: area.parent, moves: moves - 1, branch, direction: "UP" });
        queue.push(...area.children.map((area2) => ({ area: area2, moves: moves + 1, branch, direction: "DOWN" })));
      }
    }
    return fromBranchAreas.reduce((acc, from) => {
      return [
        ...acc,
        ...toBranchAreas.map((to) => {
          return [from.area, to.area, Math.abs(from.moves) + Math.abs(to.moves)];
        })
      ];
    }, []);
  }
  // méthode pour un tri par ordre de fréquence des mots clés
  smartSort(query, limit = 20) {
    const lowerTextSearch = query.toLowerCase();
    const searchedAreas = [...this.recentChildren].filter((a) => a.name.toLowerCase().includes(lowerTextSearch));
    const lastWord = lowerTextSearch.match(/\b\w+\b/g)?.pop();
    if (!lastWord) {
      return [];
    }
    const regex = new RegExp(`${lowerTextSearch}[A-Za-z0-9_]*`, "g");
    const splitSearch = this.recentChildren.flatMap((area) => area.name.toLowerCase().match(regex));
    let words = {};
    for (const word of splitSearch) {
      if (word) {
        words[word] = words[word] ? words[word] + 1 : 1;
      }
    }
    const res = searchedAreas.sort((a, b) => {
      const bName = b.name.toLowerCase();
      const aName = a.name.toLowerCase();
      const bLastWord = bName.match(/\b\w+\b/g)?.pop();
      const aLastWord = aName.match(/\b\w+\b/g)?.pop();
      if (!aName.includes(lowerTextSearch) || bName === lowerTextSearch) {
        return 1;
      }
      if (!bName.includes(lowerTextSearch) || aName === lowerTextSearch) {
        return -1;
      }
      if (!aLastWord) {
        return 1;
      }
      if (!bLastWord) {
        return -1;
      }
      if (aLastWord === lastWord && bLastWord !== lastWord) {
        return -1;
      }
      if (bLastWord === lastWord && aLastWord !== lastWord) {
        return 1;
      }
      const na = findAreaKeyWord(a, words);
      const nb = findAreaKeyWord(b, words);
      return na - nb;
    });
    return res.slice(0, limit);
  }
  search(query, limit = 200) {
    const lowerTextSearch = query.toLowerCase();
    const searchedAreas = [...this.recentChildren].filter((a) => a.name.toLowerCase().includes(lowerTextSearch));
    const res = searchedAreas.sort((a, b) => {
      const aWords = a.name.split(" ");
      const bWords = b.name.split(" ");
      for (let i = 0; i < Math.min(aWords.length, bWords.length); i++) {
        const aWord = aWords[i];
        const bWord = bWords[i];
        const aNum = Number(aWord);
        const bNum = Number(bWord);
        if (isNaN(aNum) && isNaN(bNum)) {
          if (aWord < bWord) {
            return -1;
          }
          if (aWord > bWord) {
            return 1;
          }
        } else if (!isNaN(aNum) && !isNaN(bNum) && aNum !== bNum) {
          return aNum - bNum;
        } else if (isNaN(aNum) && !isNaN(bNum)) {
          return 1;
        } else if (!isNaN(aNum) && isNaN(bNum)) {
          return -1;
        }
      }
      return 0;
    });
    return res.slice(0, limit);
  }
};

// src/models/Config.ts
var Config = class extends ParseClass {
  constructor(attributes) {
    super("Config", attributes);
  }
  get key() {
    return this.Get("key");
  }
  set key(val) {
    this.Set("key", val);
  }
  get value() {
    return this.Get("value");
  }
  set value(val) {
    this.Set("value", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("Config", Config);

// src/models/FareAssignation.ts
var FareAssignation = class extends ParseClass {
  constructor(attributes) {
    super("FareAssignation", attributes);
  }
  get fare() {
    return this.Get("fare");
  }
  set fare(val) {
    this.Set("fare", val);
  }
  get porter() {
    return this.Get("porter");
  }
  set porter(val) {
    this.Set("porter", val);
  }
  get acknowledgedAt() {
    return this.Get("acknowledgedAt");
  }
  set acknowledgedAt(val) {
    this.Set("acknowledgedAt", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("FareAssignation", FareAssignation);

// src/models/Journey.ts
var Journey = class extends ParseClass {
  constructor(attributes) {
    super("Journey", attributes);
  }
  get fares() {
    return this.Get("fares");
  }
  set fares(val) {
    this.Set("fares", val);
  }
  get roundTrip() {
    return this.Get("roundTrip");
  }
  set roundTrip(val) {
    this.Set("roundTrip", val);
  }
  get startingUnit() {
    return this.Get("startingUnit");
  }
  set startingUnit(val) {
    this.Set("startingUnit", val);
  }
  get startingArea() {
    return this.Get("startingArea");
  }
  set startingArea(val) {
    this.Set("startingArea", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("Journey", Journey);

// src/models/Migration.ts
var migrationStatuses = ["PROCESSING", "ERROR", "SUCCESS"];
var Migration = class extends ParseClass {
  constructor(attributes) {
    super("Migration", attributes);
  }
  get scriptName() {
    return this.Get("scriptName");
  }
  set scriptName(val) {
    this.Set("scriptName", val);
  }
  get status() {
    return this.Get("status");
  }
  set status(val) {
    this.Set("status", val);
  }
  get lastRunAt() {
    return this.Get("lastRunAt");
  }
  set lastRunAt(val) {
    this.Set("lastRunAt", val);
  }
  get hash() {
    return this.Get("hash");
  }
  set hash(val) {
    this.Set("hash", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("Migration", Migration);

// src/models/Movement.ts
var Movement = class extends ParseClass {
  constructor(attributes) {
    super("Movement", attributes);
  }
  get visit() {
    return this.Get("visit");
  }
  set visit(val) {
    this.Set("visit", val);
  }
  get date() {
    return this.Get("date");
  }
  set date(val) {
    this.Set("date", val);
  }
  set movementId(value) {
    this.Set("movementId", value);
  }
  get movementId() {
    return this.Get("movementId");
  }
  get status() {
    return this.Get("status");
  }
  set status(value) {
    this.Set("status", value);
  }
  get type() {
    return this.Get("type");
  }
  set type(value) {
    this.Set("type", value);
  }
  get lastMessageId() {
    return this.Get("lastMessageId");
  }
  set lastMessageId(value) {
    this.Set("lastMessageId", value);
  }
};
parse_instance_browser_default.Object.registerSubclass("Movement", Movement);

// src/models/PathDefaultTime.ts
var PathDefaultTime = class extends ParseClass {
  constructor(attributes) {
    super("PathDefaultTime", attributes);
  }
  get fromArea() {
    return this.Get("fromArea");
  }
  set fromArea(val) {
    this.Set("fromArea", val);
  }
  get toArea() {
    return this.Get("toArea");
  }
  set toArea(val) {
    this.Set("toArea", val);
  }
  get weight() {
    return this.Get("weight");
  }
  set weight(val) {
    this.Set("weight", val);
  }
  get durationInSeconds() {
    return this.Get("durationInSeconds");
  }
  set durationInSeconds(val) {
    this.Set("durationInSeconds", val);
  }
  get position() {
    return this.Get("position");
  }
  set position(val) {
    this.Set("position", val);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("PathDefaultTime", PathDefaultTime);

// src/models/Practitioner.ts
var Practitioner = class extends ParseClass {
  constructor(attributes) {
    super("Practitioner", attributes);
  }
  get firstName() {
    return this.Get("firstName");
  }
  set firstName(val) {
    this.Set("firstName", val);
  }
  get lastName() {
    return this.Get("lastName");
  }
  set lastName(val) {
    this.Set("lastName", val);
  }
  get unit() {
    return this.Get("unit");
  }
  set unit(val) {
    this.Set("unit", val);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get color() {
    return this.Get("color");
  }
  set color(val) {
    this.Set("color", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("Practitioner", Practitioner);

// src/models/ThesaurusItem.ts
var ThesaurusItem = class extends ParseClass {
  constructor(attributes) {
    super("ThesaurusItem", attributes);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get reason() {
    return this.Get("reason");
  }
  set reason(val) {
    this.Set("reason", val);
  }
  get expectedDurationInMinutes() {
    return this.Get("expectedDurationInMinutes");
  }
  set expectedDurationInMinutes(val) {
    this.Set("expectedDurationInMinutes", val);
  }
  get redirection() {
    return this.Get("redirection");
  }
  set redirection(val) {
    this.Set("redirection", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("ThesaurusItem", ThesaurusItem);

// src/models/UnitOccupancy.ts
var UnitOccupancy = class extends ParseClass {
  constructor(attributes) {
    super("UnitOccupancy", attributes);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get unit() {
    return this.Get("unit");
  }
  set unit(val) {
    this.Set("unit", val);
  }
  get comment() {
    return this.Get("comment");
  }
  set comment(val) {
    this.Set("comment", val);
  }
  get covid() {
    return this.Get("covid");
  }
  set covid(val) {
    this.Set("covid", val);
  }
  get isolated() {
    return this.Get("isolated");
  }
  set isolated(val) {
    this.Set("isolated", val);
  }
  get accomodated() {
    return this.Get("accomodated");
  }
  set accomodated(val) {
    this.Set("accomodated", val);
  }
  get waitingForDownstreamBed() {
    return this.Get("waitingForDownstreamBed");
  }
  set waitingForDownstreamBed(val) {
    this.Set("waitingForDownstreamBed", val);
  }
  get open() {
    return this.Get("open");
  }
  set open(val) {
    this.Set("open", val);
  }
  get close() {
    return this.Get("close");
  }
  set close(val) {
    this.Set("close", val);
  }
  get admission() {
    return this.Get("admission");
  }
  set admission(val) {
    this.Set("admission", val);
  }
  get discharge() {
    return this.Get("discharge");
  }
  set discharge(val) {
    this.Set("discharge", val);
  }
  get unavailableExcluded() {
    return this.Get("unavailableExcluded");
  }
  set unavailableExcluded(val) {
    this.Set("unavailableExcluded", val);
  }
  get h24Availabilities() {
    return this.Get("h24Availabilities");
  }
  set h24Availabilities(val) {
    this.Set("h24Availabilities", val);
  }
  get h48Availabilities() {
    return this.Get("h48Availabilities");
  }
  set h48Availabilities(val) {
    this.Set("h48Availabilities", val);
  }
  get dDayAvailabilities() {
    return this.Get("dDayAvailabilities");
  }
  set dDayAvailabilities(val) {
    this.Set("dDayAvailabilities", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("UnitOccupancy", UnitOccupancy);

// src/utils/LocationUtils.ts
var encodeExternalIdToUtf8 = (stringToEncode) => Buffer.from(stringToEncode, "utf8").toString();
var getUnitFromArea = async (area) => {
  if (!area.healthCenter) {
    return;
  }
  const unit = await new parse_instance_browser_default.Query(Unit).equalTo("healthCenter", area.healthCenter).equalTo("areas", area).first({ useMasterKey: true });
  if (unit) {
    return unit;
  }
  if (!area.parent?.id) {
    return;
  }
  const parent = await new parse_instance_browser_default.Query(Area).equalTo("objectId", area.parent.id).select(["healthCenter", "parent"]).first({ useMasterKey: true });
  if (!parent) {
    return;
  }
  return getUnitFromArea(parent);
};

// src/utils/notifications.ts
var findUserConfigurationOrDefault = (user, triggerEvent) => {
  return user.notificationConfigurations?.find((config) => config.triggerEvent === triggerEvent) || DEFAULT_NOTIFICATION_CONFIGURATION[triggerEvent];
};

// src/utils/occupancy/computeOccupancy.ts
var getAvailableBeds = (male, female, indifferent) => {
  return male === void 0 && female === void 0 && indifferent === void 0 ? void 0 : (male || 0) + (female || 0) + (indifferent || 0);
};
var computeOccupancy = (occupancies) => {
  let open = 0;
  let covid = 0;
  let waitingForDownstreamBed = 0;
  let accomodated = 0;
  let close = 0;
  let dDayAvailabilities = { female: 0, male: 0, indifferent: 0 };
  let h24Availabilities = { female: 0, male: 0, indifferent: 0 };
  let h48Availabilities = { female: 0, male: 0, indifferent: 0 };
  let admission = 0;
  let discharge = 0;
  let updatedAt = /* @__PURE__ */ new Date();
  let available = 0;
  let unavailableExcluded = 0;
  for (let occupancy of occupancies) {
    if (occupancy?.open !== void 0) {
      open = open + occupancy.open;
    }
    if (occupancy?.covid !== void 0) {
      covid = covid + occupancy.covid;
    }
    if (occupancy?.waitingForDownstreamBed !== void 0) {
      waitingForDownstreamBed = waitingForDownstreamBed + occupancy.waitingForDownstreamBed;
    }
    if (occupancy?.unavailableExcluded !== void 0) {
      unavailableExcluded = unavailableExcluded + occupancy.unavailableExcluded;
    }
    const availableUnitBeds = getAvailableBeds(
      occupancy?.dDayAvailabilities?.male,
      occupancy?.dDayAvailabilities?.female,
      occupancy?.dDayAvailabilities?.indifferent
    );
    if (availableUnitBeds !== void 0) {
      available = available + availableUnitBeds;
    }
    if (occupancy?.accomodated !== void 0) {
      accomodated = accomodated + occupancy.accomodated;
    }
    if (occupancy?.close !== void 0) {
      close = close + occupancy.close;
    }
    if (occupancy?.dDayAvailabilities !== void 0) {
      if (occupancy?.dDayAvailabilities.male !== void 0) {
        dDayAvailabilities.male = dDayAvailabilities.male + occupancy.dDayAvailabilities.male;
      }
      if (occupancy?.dDayAvailabilities.female !== void 0) {
        dDayAvailabilities.female = dDayAvailabilities.female + occupancy.dDayAvailabilities.female;
      }
      if (occupancy?.dDayAvailabilities.indifferent !== void 0) {
        dDayAvailabilities.indifferent = dDayAvailabilities.indifferent + occupancy.dDayAvailabilities.indifferent;
      }
    }
    if (occupancy?.h24Availabilities !== void 0) {
      if (occupancy?.h24Availabilities.male !== void 0) {
        h24Availabilities.male = h24Availabilities.male + occupancy.h24Availabilities.male;
      }
      if (occupancy?.h24Availabilities.female !== void 0) {
        h24Availabilities.female = h24Availabilities.female + occupancy.h24Availabilities.female;
      }
      if (occupancy?.h24Availabilities.indifferent !== void 0) {
        h24Availabilities.indifferent = h24Availabilities.indifferent + occupancy.h24Availabilities.indifferent;
      }
    }
    if (occupancy?.h48Availabilities !== void 0) {
      if (occupancy?.h48Availabilities.male !== void 0) {
        h48Availabilities.male = h48Availabilities.male + occupancy.h48Availabilities.male;
      }
      if (occupancy?.h48Availabilities.female !== void 0) {
        h48Availabilities.female = h48Availabilities.female + occupancy.h48Availabilities.female;
      }
      if (occupancy?.h48Availabilities.indifferent !== void 0) {
        h48Availabilities.indifferent = h48Availabilities.indifferent + occupancy.h48Availabilities.indifferent;
      }
    }
    if (occupancy?.admission !== void 0) {
      admission = admission + occupancy.admission;
    }
    if (occupancy?.discharge !== void 0) {
      discharge = discharge + occupancy.discharge;
    }
    if (occupancy?.updatedAt) {
      updatedAt = new Date(Math.min(updatedAt.getTime(), occupancy.updatedAt.getTime()));
    }
  }
  const occupied = open - available + unavailableExcluded;
  const rate = open ? Math.round(occupied * 100 / open) : 0;
  const total = open + close;
  return {
    covid,
    waitingForDownstreamBed,
    accomodated,
    open,
    available,
    occupied,
    rate,
    updatedAt,
    close,
    admission,
    dDayAvailabilities,
    h24Availabilities,
    h48Availabilities,
    discharge,
    unavailableExcluded,
    total
  };
};

// src/utils/occupancy/getBedOccupancy.ts
var getBedOccupancy = (dDaySnapshot, h24Snapshot, h48Snapshot, dDayAdmission, dDayDischarge, pendingH24Snapshot) => {
  const dDayAvailabilities = getDDayGenderAvailability(dDaySnapshot, pendingH24Snapshot);
  return {
    covid: dDaySnapshot.specificities.includes("COVID") ? 1 : 0,
    accomodated: dDaySnapshot.specificities.includes("ACCOMMODATED") || dDaySnapshot.responsibleUnit?.id && dDaySnapshot.unit?.id !== dDaySnapshot.responsibleUnit.id ? 1 : 0,
    isolated: dDaySnapshot.specificities.includes("ISOLATED") ? 1 : 0,
    isolatedAir: dDaySnapshot.specificities.includes("ISOLATED_AIR") ? 1 : 0,
    isolatedDroplet: dDaySnapshot.specificities.includes("ISOLATED_DROPLET") ? 1 : 0,
    isolatedContact: dDaySnapshot.specificities.includes("ISOLATED_CONTACT") ? 1 : 0,
    isolatedProtector: dDaySnapshot.specificities.includes("ISOLATED_PROTECTOR") ? 1 : 0,
    close: dDaySnapshot.status === "CLOSED" && !dDaySnapshot.excludedFromOccupancy ? 1 : 0,
    waitingForDownstreamBed: dDaySnapshot.specificities.includes("WAITING_FOR_DOWNSTREAM_BED") ? 1 : 0,
    open: dDaySnapshot.status !== "CLOSED" && !dDaySnapshot.excludedFromOccupancy ? 1 : 0,
    dDayAvailabilities,
    h24Availabilities: getGenderAvailability(h24Snapshot),
    h48Availabilities: getGenderAvailability(h48Snapshot),
    admission: dDayAdmission,
    discharge: dDayDischarge,
    unavailableExcluded: (dDaySnapshot.status !== "AVAILABLE" || pendingH24Snapshot.status !== "AVAILABLE") && dDaySnapshot.excludedFromOccupancy ? 1 : 0,
    updatedAt: /* @__PURE__ */ new Date()
  };
};
var getGenderAvailability = (snapshot) => {
  if (!snapshot.excludedFromOccupancy) {
    return {
      female: snapshot.gender === "FEMALE" && snapshot.status === "AVAILABLE" ? 1 : 0,
      indifferent: snapshot.gender === "UNKNOWN" && snapshot.status === "AVAILABLE" ? 1 : 0,
      male: snapshot.gender === "MALE" && snapshot.status === "AVAILABLE" ? 1 : 0
    };
  }
  return {
    male: 0,
    female: 0,
    indifferent: 0
  };
};
var getDDayGenderAvailability = (dDaySnapshot, pendingH24Snapshot) => {
  const isTomorrowAvailable = pendingH24Snapshot.status === "AVAILABLE" && !pendingH24Snapshot.excludedFromOccupancy;
  const isDDayAvailable = dDaySnapshot.status === "AVAILABLE" && !dDaySnapshot.excludedFromOccupancy;
  if (!(isTomorrowAvailable && isDDayAvailable)) {
    return {
      female: 0,
      male: 0,
      indifferent: 0
    };
  } else if (!isTomorrowAvailable) {
    return {
      female: pendingH24Snapshot.gender === "FEMALE" ? 1 : 0,
      indifferent: pendingH24Snapshot.gender === "UNKNOWN" ? 1 : 0,
      male: pendingH24Snapshot.gender === "MALE" ? 1 : 0
    };
  }
  return {
    female: dDaySnapshot.gender === "FEMALE" ? 1 : 0,
    indifferent: dDaySnapshot.gender === "UNKNOWN" ? 1 : 0,
    male: dDaySnapshot.gender === "MALE" ? 1 : 0
  };
};

// src/utils/occupancy/getBedSnapshot.ts
var getBedStatus = (accommodation) => {
  if (accommodation) {
    const hasVisit = !!accommodation.visit;
    return hasVisit ? "BUSY" : "CLOSED";
  }
  return "AVAILABLE";
};
var getBedGender = (accommodationsRoom, accommodation) => {
  if (!accommodationsRoom.length && !accommodation) {
    return "UNKNOWN";
  }
  if (accommodation?.visit) {
    return accommodation.visit.gender;
  }
  const female = accommodationsRoom.some((accommodation2) => accommodation2.visit?.gender === "FEMALE");
  const male = accommodationsRoom.some((accommodation2) => accommodation2.visit?.gender === "MALE");
  if (female === male) {
    return "UNKNOWN";
  }
  if (female) {
    return "FEMALE";
  }
  return "MALE";
};
var getBedSnapshot = ({
  id,
  excludedFromOccupancy,
  accommodationsRoom,
  accommodation
}) => ({
  id,
  excludedFromOccupancy,
  gender: getBedGender(accommodationsRoom, accommodation),
  specificities: accommodation?.specificities || [],
  unit: accommodation?.unit,
  responsibleUnit: accommodation?.responsibleUnit,
  status: getBedStatus(accommodation)
});

// src/utils/users/password.ts
var generatePassword = (length = 20, characters = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz~!@-#$") => Array.from(crypto.getRandomValues(new Uint32Array(length))).map((x) => characters[x % characters.length]).join("");
var isPinValid = (pin) => {
  const is4Digits = pin.length === 4;
  const hasOnlyDigits = /^\d+$/.test(pin);
  return {
    valid: is4Digits && hasOnlyDigits,
    is4Digits,
    hasOnlyDigits
  };
};
var generateRandomPin = () => generatePassword(4, "0123456789");
var isPasswordValid = (password) => {
  const isAtLeast12Characters = password.length >= 12;
  const hasAtLeastOneUppercaseLetter = /[A-Z]/.test(password);
  const hasAtLeastOneDigit = /[0-9]/.test(password);
  const hasAtLeastOneSpecialCharacter = /[!@#$%^&*()_+\-=\]{};':"\\|,.<>?]+/.test(password);
  return {
    valid: isAtLeast12Characters && hasAtLeastOneUppercaseLetter && hasAtLeastOneDigit && hasAtLeastOneSpecialCharacter,
    isAtLeast12Characters,
    hasAtLeastOneUppercaseLetter,
    hasAtLeastOneDigit,
    hasAtLeastOneSpecialCharacter
  };
};
var generateRandomPassword = () => {
  const password = generatePassword(20);
  return isPasswordValid(password).valid ? password : generateRandomPassword();
};
var generateRandomUserPassword = (role) => {
  if (true) {
    return role === "PORTER" ? "1234" : "foo";
  }
  return role === "PORTER" ? generateRandomPin() : generateRandomPassword();
};
var validateUserPassword = (password, role) => role === "PORTER" ? isPinValid(password).valid : isPasswordValid(password).valid;

// src/utils/users/role.ts
var ACCESSIBLE_ROLES = {
  PORTER: [],
  REGULATOR: ["PORTER", "REGULATOR", "MANAGER"],
  MANAGER: ["PORTER", "REGULATOR", "MANAGER"],
  BED_MANAGER: ["PORTER", "REGULATOR", "MANAGER", "BED_MANAGER"],
  ADMIN_REGULATOR: ["PORTER", "REGULATOR", "MANAGER", "BED_MANAGER", "ADMIN_REGULATOR", "ADMIN"],
  ADMIN: ["PORTER", "REGULATOR", "MANAGER", "BED_MANAGER", "ADMIN_REGULATOR", "ADMIN"]
};
var getAccessibleRoles = (role) => ACCESSIBLE_ROLES[role];
var hasUserAccessToRole = (user, role) => getAccessibleRoles(user?.role).includes(role);

// src/index.esm.ts
var index_esm_default = parse_instance_browser_default;
export {
  ACCESSIBLE_ROLES,
  ADMIN_ROUTES,
  Accommodation,
  AccommodationRequest,
  Anomaly,
  Appointment,
  Area,
  AreaTree,
  cloud_exports as Cloud,
  Config,
  DEFAULT_HEALTH_CENTER_TIMEZONE,
  DEFAULT_NOTIFICATION_CONFIGURATION,
  EmergencyOccupancy,
  ExternalPatientTransport,
  FARE_ASSIGNED_DEFAULT_CONFIGURATION,
  FARE_READY_TO_BE_ASSIGNED_DEFAULT_CONFIGURATION,
  FARE_UNASSIGNED_DEFAULT_CONFIGURATION,
  FARE_UPDATED_DEFAULT_CONFIGURATION,
  Fare,
  FareAssignation,
  HealthCenter,
  HealthcareEnvironmentalCleaning,
  Incident,
  interop_exports as Interop,
  InteropMessage,
  Journey,
  KURT_ROUTES,
  Migration,
  Movement,
  NAVIGATION_ROUTES,
  NEW_FARE_INCIDENT_DEFAULT_CONFIGURATION,
  NEW_PERFORMER_REQUEST_DEFAULT_CONFIGURATION,
  Notification,
  PERFORMER_REQUEST_ACCEPTED_DEFAULT_CONFIGURATION,
  PERFORMER_REQUEST_REJECTED_DEFAULT_CONFIGURATION,
  PORTER_END_OF_SERVICE_DEFAULT_CONFIGURATION,
  PORTER_START_OF_SERVICE_DEFAULT_CONFIGURATION,
  PORTER_SUPPORT_ASSIGNED_DEFAULT_CONFIGURATION,
  PORTER_SUPPORT_UNASSIGNED_DEFAULT_CONFIGURATION,
  PathDefaultTime,
  Patient,
  PatientIdentity,
  PerformerRequest,
  Porter,
  Practitioner,
  REQUEST_TYPES,
  SABRI_ROUTES,
  ThesaurusItem,
  Unit,
  UnitOccupancy,
  User,
  accommodationSpecificities,
  accommodationStatus,
  addMonths,
  anomalyStatus,
  anomalyType,
  appointmentStatus,
  availabilityPeriodStatus,
  cancellableConfirmedFareStatus,
  computeEmergencyOccupanciesOptions,
  computeOccupancy,
  contactPointSystems,
  contactPointUses,
  index_esm_default as default,
  delayRuleTypes,
  emergencyOccupancyKey,
  emergencyOccupancyService,
  encodeExternalIdToUtf8,
  externalPatientTransportPosition,
  externalTypeCodes,
  farePositions,
  fareSpecificities,
  fareStatus,
  findUserConfigurationOrDefault,
  generateRandomPassword,
  generateRandomPin,
  generateRandomUserPassword,
  getAccessibleRoles,
  getAvailableBeds,
  getBedGender,
  getBedOccupancy,
  getBedSnapshot,
  getBedStatus,
  getFaresDifferences,
  getSectorBySpecialty,
  getSectorsBySpecialties,
  getSpecialtiesBySector,
  getSpecialtiesBySectors,
  getUnitFromArea,
  hasUserAccessToRole,
  healthcareEnvironmentalCleaningStatus,
  incidentReasons,
  isIsolatedSpecificity,
  isPasswordValid,
  isPinValid,
  isolatedSpecificities,
  maxDate,
  migrationStatuses,
  minDate,
  notificationConfigurationValidation,
  notificationProvider,
  notificationTriggerEvent,
  patientCreationSources,
  patientGender,
  patientOutcomeTypes,
  porterBreak,
  rorTypes,
  specificitiesOrder,
  specificitiesSorter,
  subMonths,
  sectors as unitSectors,
  specialties as unitSpecialties,
  unitTypes,
  userRoles,
  validateUserPassword,
  webUserRoles
};
